/**
 * Korean translations for documentation pages
 */

const ko: Record<string, string> = {
  // Common
  'common.backToHome': '홈으로 돌아가기',
  'common.backToDocs': '문서로 돌아가기',
  'common.learnMore': '더 알아보기',
  'common.getStarted': '시작하기',
  'common.viewDocs': '문서 보기',
  'common.signIn': '로그인',
  'common.signUp': '회원가입',
  'common.dashboard': '대시보드',
  'common.footer': '2025 Kizuna AI Lab. 모든 권리 보유.',
  'common.language': '언어',

  // Theme
  'theme.label': '테마',
  'theme.light': '라이트',
  'theme.dark': '다크',
  'theme.system': '시스템',

  // Navigation
  'nav.home': '홈',
  'nav.docs': '문서',
  'nav.scenarios': '시나리오',
  'nav.features': '기능',
  'nav.signIn': '로그인',
  'nav.providers': '제공자',
  'nav.docsShort': '문서',
  'footer.tagline': 'Kizuna AI Lab이 만듭니다. 장벽을 허물고, 연결을 짓습니다.',
  'footer.trust': '무료 오픈소스 · 온디바이스 AI 포함 · 구독 없음',
  'footer.product': '제품',
  'footer.install': '설치',
  'footer.open': '공개',
  'footer.byok': '자기 키 사용',
  'footer.extension': '확장 프로그램',
  'footer.gettingStarted': '시작하기',
  'footer.meetingSites': '회의 사이트',
  'footer.providerSetup': '제공자 설정',
  'footer.subtitleMode': '자막 모드',
  'nav.localAi': '로컬 AI',
  'nav.download': '다운로드',
  'demo.me': '나',
  'demo.other': '상대',
  'demo.both': '양쪽',
  'demo.src': '원문',
  'demo.trans': '번역',
  'demo.subtitle': '자막',
  'demo.exitSubtitle': '자막 모드 종료',
  'demo.settings': '설정',
  'demo.channel.mic': '당신의 마이크',
  'demo.channel.sys': '상대의 소리',
  'demo.channel.out': 'Sokuji가 말하는 소리',
  'demo.endSession': '세션 종료',
  'home.scenarios.title': '무엇을 하려고 하시나요?',
  'home.scenarios.lead': 'Sokuji는 언어를 건너는 비용을 “이해받고 싶은 쪽”이 지도록 만들어졌습니다. 우리가 가장 먼저 만든 것이 그것입니다. 하지만 당신이 늘 그쪽인 것은 아닙니다 — 강의를 듣고 있을 수도, 녹음을 재생 중일 수도, 남이 만든 통화에 들어가 있을 수도 있습니다.',
  'home.scenarios.featured': '우리가 가장 먼저 만든 것',
  'home.scenarios.more': '각 프리셋이 설정하는 것',
  'home.install.title': '앱을 설치하거나, 브라우저에 추가하세요',
  'home.install.lead': '데스크톱 앱은 지원 사이트 목록에 묶이지 않습니다. 시스템에 평범한 마이크로 등록되므로, 마이크를 고를 수 있는 것이면 무엇이든 쓸 수 있습니다.',
  'home.install.desktop.title': '데스크톱 앱 — 시스템 레벨',
  'home.install.desktop.body': 'Sokuji는 운영체제에서 평범한 마이크로 나타납니다. 회의 앱, 브라우저, 녹음 도구, 스트리밍 소프트웨어, 게임 — 마이크를 고를 수 있다면 번역된 당신의 목소리가 전달됩니다.',
  'home.install.desktop.note': '반대 방향은 누구의 허락도 필요 없습니다. Sokuji는 기기가 재생 중인 소리를 그대로 읽으므로, 시스템 사운드를 포함해 영상도 스트리밍도 녹음도 통화와 똑같이 자막이 됩니다.',
  'home.install.routing.linux': 'PulseAudio 또는 PipeWire에 기본 내장',
  'home.install.routing.macos': '드라이버가 앱에 포함',
  'home.install.routing.windows': 'VB-CABLE 경유',
  'home.install.ext.title': '브라우저 확장 프로그램',
  'home.install.ext.body': '시스템에는 아무것도 설치하지 않고 오디오 라우팅도 설정할 필요가 없습니다. 지원하는 회의 사이트를 위해 만들어졌습니다.',
  'home.install.ext.note': '그 페이지 안에서는 번역된 당신의 목소리가 사이트에 마이크로 전달되고, 탭 자체의 오디오가 번역되어 돌아옵니다. 그 밖의 곳 — 다른 앱, 브라우저 밖의 영상, 시스템 사운드 — 은 데스크톱 앱의 몫입니다.',
  'flow.youSpeak': '당신이 말하고',
  'flow.translates': 'sokuji가 번역',
  'flow.virtualMic': '가상 마이크',
  'flow.anyApp': '임의의 앱',
  'flow.theyHear': '상대가 듣기',
  'flow.them': '상대',
  'flow.yourScreen': '당신의 화면',
  'flow.audience': '청중',
  'flow.onScreen': '화면에',
  'providers.page.title': '번역이 실제로 일어나는 곳',
  'providers.page.lead': 'Sokuji가 직접 인식이나 번역을 하지는 않습니다. 당신의 목소리를 잡아 어딘가로 보내고, 돌아온 답을 통화에 말해 줍니다. 그 “어딘가”를 고르는 건 당신입니다. 길은 셋이고, 어느 하나에 묶이지 않습니다.',
  'providers.routes.title': '세 가지 길',
  'providers.local.chip': '무료 · 계정 불필요 · 오프라인',
  'providers.own.chip': '키는 당신이 · 청구도 당신에게',
  'providers.managed.chip': '사용량 과금 · 구독 없음',
  'providers.table.title': '지원 제공자',
  'providers.table.lead': 'Sokuji는 이들의 어댑터를 함께 제공합니다. “말함”은 텍스트만이 아니라 발화된 번역을 만들 수 있다는 뜻이고, 대표 시나리오가 필요로 하는 것이 그것입니다. Kizuna AI 계정을 쓸 수 있는 줄에는 실제로 모델을 돌리는 업체 이름을 적었습니다. 당신의 오디오를 받는 곳이 거기이기 때문입니다. “마주 보고 대화”는 두 사람이 마이크 하나를 함께 쓰고, 각자 이어버드 한쪽으로 상대의 번역을 듣는 방식입니다. 이를 할 수 있는 제공자는 상대 쪽의 여러 화자도 구별합니다.',
  'providers.col.provider': '제공자',
  'providers.col.runs': '실행 방식',
  'providers.col.speaks': '말함',
  'providers.col.faceToFace': '마주 보고 대화',
  'providers.col.setup': '설정',
  'providers.speaks.yes': '예',
  'providers.speaks.textOnly': '텍스트만',
  'providers.speaks.depends': '경우에 따라',
  'providers.faceToFace.yes': '가능',
  'providers.faceToFace.no': '불가',
  'providers.guide': '가이드',
  'providers.run.local': '당신의 기기에서, GPU에 맞춰 엔진을 내려받음',
  'providers.run.direct': '당신의 키로 {vendor}에 직접',
  'providers.run.keyOrAccount': '당신의 키, 또는 Kizuna AI 계정 — 업체: {vendor}',
  'providers.run.webrtc': '당신의 키, WebRTC 전송',
  'providers.cost.title': '계정에 드는 비용',
  'providers.cost.lead': '돈이 드는 것은 이 길뿐입니다. Sokuji 자체는 무료 오픈소스이고, 온디바이스 추론도 함께 무료입니다.',
  'providers.cost.metered.title': '사용량 과금, 월정액 아님',
  'providers.cost.metered.body': '잔액을 충전하고 쓰는 만큼 차감됩니다. 쓰지 않은 달은 0원이고, 좌석 수도 없습니다.',
  'providers.cost.metered.body2': '여기에 단일 가격을 적을 수 없는 이유는 업체마다 계량 방식이 다르기 때문입니다 — 오디오 길이로 재는 곳도, 모델이 처리한 양으로 재는 곳도 있습니다. 실제 적용되는 요율은 돈을 쓰기 전에 계정 안 그 업체 옆에 표시됩니다.',
  'providers.cost.path.title': '그래도 경로에는 없음',
  'providers.cost.path.body': '우리에게 돈을 낸다고 해서 우리가 당신과 모델 사이에 끼는 것은 아닙니다. 우리는 기기에 자격 증명을 건네고 그 사용량을 셀 뿐이며, 오디오는 자기 키를 쓸 때와 똑같이 기기에서 업체로 곧장 갑니다.',
  'providers.cost.wired': '어떻게 연결되어 있는지 보기',
  'providers.cost.note': '잔액의 유효기간은 1년입니다. 이 기한이 있는 이유는 쓰지 않은 크레딧이 우리 장부에 부채로 남기 때문이지, 누구를 쓰게 떠밀기 위해서가 아닙니다.',
  'providers.own.title': '당신의 API 키',
  'providers.own.body': '아래 어떤 제공자든 가입해서 키를 Sokuji에 붙여 넣고, 그 제공자에게 직접 결제하면 됩니다. 각각에 대해 스크린샷이 있는 안내를 써 두었습니다. 우리를 거치는 것은 전혀 없습니다.',
  'providers.managed.title': 'Kizuna AI 계정을 통해',
  'providers.managed.body': '개발자 콘솔을 만지고 싶지 않은 사람들을 위해. 키는 우리가 들고 결제도 우리가 처리하지만, 모델을 돌리는 것은 여전히 Soniox 또는 Qwen입니다. 오디오는 그들에게 곧장 가고, 우리는 경로에 없습니다.',
  'providers.local.title': '당신의 기기 위에서',
  'providers.local.body': 'GPU에 맞는 추론 엔진을 내려받아 인식과 번역을 로컬에서 돌립니다. 무료이고, 네트워크를 꺼도 동작하며, 기기 밖으로 나가는 것이 없습니다 — 우리에게도.',
  'providers.price.title': '여기에 요금을 적지 않는 이유',
  'providers.price.body': '업체마다 과금 방식이 다릅니다 — 분 단위, 문자 단위, 토큰 단위, 요청 단위 — 게다가 같은 1분의 발화라도 내용에 따라 금액이 달라집니다. 이 페이지에 숫자 하나를 박아 두면 읽는 사람 대부분에게 틀린 값이 됩니다. 당신에게 적용되는 요금은 해당 업체별로 계정 화면에 표시됩니다.',
  'localai.page.title': '온디바이스는 대체 수단이 아닙니다',
  'localai.page.lead': 'Sokuji는 기기 위에서 도는 인식·번역·음성 합성을 무료로 함께 제공합니다. 네트워크가 끊겼을 때를 위한 것이 아니라 일급 경로이고, 언젠가 기본값이 되리라 봅니다.',
  'localai.honest.lead': '과장해서 파느니, 분명히 말해 두겠습니다.',
  'localai.tomorrow.strong': 'AI를 쓰겠다는 이유만으로 자기 대화를 거대 AI 기업에 넘겨야 할 사람은 없습니다.',
  'localai.data.title': '각 경로가 당신의 데이터에 뜻하는 것',
  'localai.data.lead': '셋 중 답에 단서가 필요 없는 것은 이 하나뿐입니다.',
  'localai.col.ownKey': '자기 키',
  'localai.col.account': 'Kizuna AI 계정',
  'localai.col.onDevice': '온디바이스',
  'localai.row.leaves': '오디오가 기기 밖으로 나감',
  'localai.row.hear': '다른 누군가가 들을 수 있음',
  'localai.row.offline': '네트워크를 꺼도 동작',
  'localai.row.costs': '비용',
  'localai.val.toVendor': '업체로',
  'localai.val.never': '전혀',
  'localai.val.vendorCan': '업체는 가능',
  'localai.val.nobody': '아무도 못 함',
  'localai.val.no': '아니요',
  'localai.val.yes': '예',
  'localai.val.vendorBills': '업체가 청구',
  'localai.val.meteredByUs': '우리가 계량',
  'localai.val.free': '무료',
  'localai.what.title': '당신의 기기에서 도는 것',
  'localai.chain.title': '인식, 번역, 음성',
  'localai.chain.body': '전 과정이 로컬에서 돕니다. ASR이 목소리를 텍스트로, MT가 번역하고, TTS가 말합니다. 어느 단계도 네트워크가 필요 없습니다.',
  'localai.engine.title': '당신의 하드웨어에 맞춘 엔진',
  'localai.engine.body': 'Sokuji가 GPU를 감지해 그에 맞춰 만들어진 엔진 패키지를 내려받고, 어떤 것을 골랐고 크기가 얼마인지 알려 줍니다.',
  'localai.nokey.title': '키도 계정도 계량도 없음',
  'localai.nokey.body': '등록할 것도, 쓸 돈도 없습니다. 비용은 당신의 하드웨어가 전부입니다.',
  'localai.honest.title': '클라우드 모델이 아직 더 나은데도 함께 넣는 이유',
  'localai.today.title': '오늘의 위치',
  'localai.today.body': '대형 호스팅 모델이 정확도와 지연에서 여전히 앞섭니다. 중요한 통화라면 아마 그쪽을 고르실 겁니다. 온디바이스 출력도 아주 많은 대화에는 충분하고, 무엇보다 당신 말고는 아무도 끼지 않는 유일한 구성입니다.',
  'localai.tomorrow.title': '우리가 보는 방향',
  'localai.tomorrow.body': '모델은 계속 작아지고, 런타임은 계속 좋아지고, 평범한 노트북의 가속기도 계속 빨라집니다. 이 격차가 오래갈 거라 보지 않고, 그것이 좁혀지기를 기다렸다가 로컬을 첫 선택으로 삼을 생각도 없습니다.',
  'privacyPage.hero.kicker': '프라이버시',
  'privacyPage.hero.title': '회의 내용은 당신과 당신이 고른 AI 사이에서만 오갑니다.',
  'privacyPage.hero.lead': 'Sokuji를 어떻게 쓰든 목소리, 화면 이미지, 전사, 번역은 당신의 기기에서 당신이 고른 AI 제공자로 곧장 가며, Kizuna AI를 거치지 않습니다. 다른 점은 그 제공자와 누가 정산하느냐뿐입니다.',
  'privacyPage.hero.exception': '단 하나의 예외: Kizuna AI 계정으로 음성을 복제할 때는, 당신이 녹음한 음성 샘플이 우리 서버를 거쳐 Soniox로 전달됩니다. 우리는 어떤 음성도 저장하지 않습니다. 샘플은 전달이 끝나면 바로 폐기되고, 서버에는 Soniox가 돌려준 음성 ID만 남습니다.',
  'privacyPage.hero.flowLabel': '회의 내용은 당신의 기기에서 당신이 고른 AI 제공자로 곧장 갑니다. Kizuna AI 계정을 쓰면 이와 별도로 Kizuna AI로 가는 선이 하나 있으며, 이 선으로는 계정, 잔액, 사용량만 오갑니다.',
  'privacyPage.node.device': '당신의 기기',
  'privacyPage.node.provider': 'AI 제공자',
  'privacyPage.node.kizuna': 'Kizuna AI',
  'privacyPage.node.stays': '내용은 이 기기 밖으로 나가지 않음',
  'privacyPage.way.ownKey.title': '자기 키로',
  'privacyPage.way.ownKey.body': 'AI 제공자에게 직접 결제하며, 당신의 세션은 우리 서버를 전혀 거치지 않습니다.',
  'privacyPage.way.ownKey.note': 'Kizuna AI: 관여하지 않음',
  'privacyPage.way.kizuna.title': 'Kizuna AI 계정으로',
  'privacyPage.way.kizuna.body': '우리가 짧은 시간 동안만 유효한 키를 발급하고 사용량에 따라 과금합니다. 그래도 내용은 AI 제공자로 곧장 갑니다.',
  'privacyPage.way.kizuna.note': '점선으로는 계정, 잔액, 사용량만 오갑니다',
  'privacyPage.way.local.title': '자기 기기에서',
  'privacyPage.way.local.body': '온디바이스 모델을 사용할 때는 모델이 당신의 컴퓨터에서 돌아가며, 회의 내용은 컴퓨터 밖으로 나가지 않습니다.',
  'privacyPage.way.local.note': '모델을 내려받은 뒤에는 오프라인으로 동작하며, 그전까지는 Microsoft의 온라인 엔진이 자동으로 쓰일 수 있음(아래 참고)',
  'privacyPage.dest.title': '데이터는 종류별로 어디로 가는가',
  'privacyPage.dest.lead': '이것이 전체 목록입니다. 여기에 없는 회의 내용은 당신의 기기를 떠나지 않습니다.',
  'privacyPage.dest.contacts': '이 밖에 Sokuji는 회의 내용을 담지 않는 연결을 몇 가지 합니다. 온디바이스 모델 내려받기, 업데이트 확인, 그리고 사용 통계와 오류 보고 전송입니다. 참고로, 로컬 추론 가운데 “온라인” 표시가 붙은 엔진(Edge TTS 음성 합성, Bing 번역기)은 당신의 컴퓨터에서 돌아가지 않습니다. 쓸 수 있는 온디바이스 모델이 없을 때 자동으로 쓰이고, 당신이 고를 때에도 쓰이며, 이때 읽어 주거나 번역할 텍스트가 Microsoft로 전송됩니다.',
  'privacyPage.dest.provider.title': '당신이 고른 AI 제공자',
  'privacyPage.dest.provider.who': '인식, 번역, 음성 합성을 맡음',
  'privacyPage.dest.provider.voices': '당신의 목소리와 상대의 목소리',
  'privacyPage.dest.provider.screen': '화면 이미지(화면 컨텍스트를 켰을 때)',
  'privacyPage.dest.provider.text': '전사와 번역',
  'privacyPage.dest.provider.voiceSample': '음성 복제용 음성 샘플',
  'privacyPage.dest.provider.foot': '각 제공자 자체의 개인정보 약관에 따라 처리됩니다.',
  'privacyPage.dest.provider.link': '제공자 목록 보기',
  'privacyPage.dest.kizuna.title': 'Kizuna AI',
  'privacyPage.dest.kizuna.who': 'Kizuna AI 계정을 쓸 때만',
  'privacyPage.dest.kizuna.email': '이메일과 가입할 때 입력한 이름(아무 닉네임이나 괜찮습니다)',
  'privacyPage.dest.kizuna.logins': '로그인 기록(IP 주소, 기기, 대략적인 위치)',
  'privacyPage.dest.kizuna.billing': '잔액, 충전, 세션별 사용량, 그리고 결제 확인에 쓰는, Stripe에서 받은 결제 정보',
  'privacyPage.dest.kizuna.feedback': '당신이 직접 보낸 피드백',
  'privacyPage.dest.kizuna.foot': '이미지, 전사, 번역은 포함되지 않습니다. 목소리도 포함되지 않으며, Soniox로 전달되는 음성 복제용 샘플만 예외입니다(위 참조).',
  'privacyPage.dest.device.title': '당신 쪽에 남는 것',
  'privacyPage.dest.device.who': '모든 모드에서',
  'privacyPage.dest.device.history': '세션 기록과 내보낸 파일',
  'privacyPage.dest.device.settings': '설정과 자기 키: 데스크톱 앱은 이를 당신의 컴퓨터에 보관하고, 모바일 앱은 설정을 당신의 휴대전화에 보관하며, 브라우저 확장 프로그램은 Chrome 동기화가 켜져 있으면 당신의 Google 계정을 통해 동기화합니다',
  'privacyPage.dest.device.local': '온디바이스 모델만 사용할 때의 모든 회의 내용',
  'privacyPage.dest.device.foot': '앱에서 삭제하거나, 브라우저 데이터를 지우거나, 앱의 데이터 폴더를 제거하거나, 모바일 앱을 삭제하면 삭제됩니다. 내보낸 파일은 저장한 위치에 그대로 남습니다.',
  'privacyPage.third.posthog.title': '사용 통계 · PostHog',
  'privacyPage.third.posthog.body': '제품을 개선하기 위해 PostHog(미국)를 사용해 사용 통계와 오류 보고를 수집합니다. 예를 들면 어떤 제공자를 썼는지, 세션 길이, 오류, 기기와 운영 체제, 그리고 브라우저 확장 프로그램에서는 확장 프로그램을 연 페이지의 호스트 이름입니다. 로그인하면 이 데이터는 당신의 계정 ID, 이메일, 가입할 때 입력한 이름과 연결됩니다. 회의 내용은 절대 포함되지 않습니다. 현재 앱 안에는 이를 끄는 스위치가 없습니다.',
  'privacyPage.third.stripe.title': '결제 · Stripe',
  'privacyPage.third.stripe.body': '충전 결제는 Stripe가 처리하며, 전체 카드 번호는 Stripe에만 전달되고 우리는 볼 수 없습니다. 결제를 대조하고 확인하기 위해 Stripe로부터 일부 결제 정보를 받습니다. 예를 들면 결제자의 이름, 이메일, 청구지 주소, 그리고 카드 브랜드와 뒤 4자리입니다.',
  'privacyPage.stored.title': '무엇을, 얼마나 오래 보관하는가',
  'privacyPage.stored.lead': '아래 데이터는 Kizuna AI 계정을 쓸 때만 우리 서버에 저장됩니다.',
  'privacyPage.stored.col.data': '데이터',
  'privacyPage.stored.col.why': '필요한 이유',
  'privacyPage.stored.col.keep': '보관 기간',
  'privacyPage.stored.email.data': '이메일과 이름',
  'privacyPage.stored.email.why': '로그인, 계정 확인, 체험 크레딧 지급',
  'privacyPage.stored.email.keep': '계정이 있는 동안',
  'privacyPage.stored.logins.data': '로그인 기록(IP 주소, 기기, 대략적인 위치)',
  'privacyPage.stored.logins.why': '로그인 상태 유지와 계정 문제 조사',
  'privacyPage.stored.logins.keep': '계정을 삭제할 때까지',
  'privacyPage.stored.abuseIps.data': '악용 방지용 IP 기록',
  'privacyPage.stored.abuseIps.why': '같은 사람이 체험 크레딧을 두 번 받는 것을 방지',
  'privacyPage.stored.abuseIps.keep': '마지막으로 확인된 후 90일',
  'privacyPage.stored.trial.data': '체험 크레딧 기록(이메일의 단방향 해시. 받기가 거부된 경우에는 일치한 IP 주소도)',
  'privacyPage.stored.trial.why': '같은 이메일 주소나 같은 사람이 체험 크레딧을 다시 받는 것을 방지',
  'privacyPage.stored.trial.keep': '장기간 보관(계정을 삭제한 뒤에도 유지)',
  'privacyPage.stored.billing.data': '잔액, 충전, 사용량, 그리고 결제 확인에 쓰는, Stripe에서 받은 결제 정보',
  'privacyPage.stored.billing.why': '과금, 결제 확인, 그리고 계정 화면에서 당신에게 표시',
  'privacyPage.stored.billing.keep': '계정이 있는 동안. 삭제 후에는 적용되는 현지 법률이 요구하는 대로 보관',
  'privacyPage.stored.feedback.data': '피드백',
  'privacyPage.stored.feedback.why': '당신에게 답장하기',
  'privacyPage.stored.feedback.keep': '우리 고객 지원 메일함에 보관',
  'privacyPage.stored.deletion': '계정은 계정 화면에서 언제든지 삭제할 수 있습니다. 삭제하면 이메일, 이름, 로그인 기록, 연결된 로그인 방법, 복제한 음성이 지워집니다. 악용 방지용 IP 기록은 위 표의 기간에 따라 자동으로 지워집니다. 체험 크레딧 기록은 체험 크레딧을 다시 받을 수 없도록 보관됩니다. 과금 기록(결제 확인에 쓰는, Stripe에서 받은 결제 정보 포함)은 법률이 요구하는 대로 보관됩니다.',
  'privacyPage.check.title': '우리 말만 믿지 않으셔도 됩니다',
  'privacyPage.check.lead': 'Sokuji는 오픈소스(AGPL-3.0)입니다. 회의 내용이 어디로 가는지에 대해 이 페이지가 하는 말은, 기술을 아는 사람이라면 누구나 확인할 수 있습니다.',
  'privacyPage.check.code.title': '코드 읽기',
  'privacyPage.check.code.body': '회의 내용이 전송되는 곳은 모두 src/providers/, src/lib/edge-tts/, src/lib/bing-translator/에 적혀 있으며, 그중 Kizuna AI는 하나도 없습니다(위에서 설명한 음성 복제용 샘플은 예외).',
  'privacyPage.check.network.title': '네트워크 요청 지켜보기',
  'privacyPage.check.network.body': '브라우저의 개발자 도구나 프록시를 열어 둔 채로 회의를 해 보세요. 회의 내용을 담은 요청은 모두 AI 제공자로 곧장 갑니다.',
  'privacyPage.check.offline.title': '네트워크를 끊고 실행',
  'privacyPage.check.offline.body': '온디바이스 모델만 사용하면, 모델을 내려받고 나서는 네트워크 연결을 끊어도 Sokuji가 계속 동작합니다.',
  'privacyPage.promise.title': '우리의 약속',
  'privacyPage.promise.noSale': '당신의 데이터를 팔거나 빌려주지 않으며, 위에 적은 서비스와 정식 개인정보 보호정책에 명시된 인프라 제공업체 외에는 누구와도 공유하지 않습니다.',
  'privacyPage.promise.noTraining': '당신의 데이터로 모델을 학습시키거나 회의를 분석하지 않습니다. 애초에 회의 내용을 받는 일이 없습니다.',
  'privacyPage.promise.trust': '계정 서버는 오픈소스가 아니므로, 이 부분은 우리를 믿어 주실 수밖에 없습니다. 그러고 싶지 않다면 Sokuji는 로그인하지 않아도 온전히 동작합니다. 자기 키를 쓰거나, 자기 기기에서 돌리면 됩니다.',
  'privacyPage.end.note': '이것은 쉬운 말로 정리한 요약입니다. 법적 효력이 있는 조항은 정식 개인정보 보호정책에 있습니다.',
  'privacyPage.end.cta': '개인정보 보호정책',
  'download.page.title': 'Sokuji 받기',
  'download.page.lead': 'Windows, macOS, Linux 모두에서 무료 오픈소스입니다. 첫 실행 전에 각 플랫폼이 요구하는 것이 조금씩 다른데, 이 페이지가 그것을 적어 둔 것입니다.',
  'download.desktop.title': '데스크톱',
  'download.desktop.lead': '데스크톱 앱은 시스템에 마이크로 등록되므로, 마이크를 고를 수 있는 프로그램이라면 무엇이든 쓸 수 있습니다.',
  'download.linux.note': 'pulseaudio-utils 필요',
  'download.windows.note': 'VB-CABLE는 따로 설치',
  'download.macos.note': '서명 및 공증 완료 · 설치 가이드 보기',
  'download.macos.noteLead': '서명 및 공증 완료 ·',
  'download.ext.addEdge': 'Edge에 추가',
  'download.ext.addChrome': 'Chrome에 추가',
  'download.macos.bodyBefore': '오디오 드라이버는 설치 프로그램 안에 들어 있으며, Apple 실리콘과 Intel 모두 지원합니다. 앱 자체는',
  'download.macos.signed': '서명되었고 Apple의 공증을 받았습니다',
  'download.macos.bodyAfter': '. 다른 Mac 앱과 똑같이 설치할 수 있습니다.',
  'download.need.linuxBefore': 'PulseAudio 또는 PipeWire 실행, 그리고',
  'download.need.linuxMid': '—',
  'download.ext.title': '브라우저 확장 프로그램',
  'download.ext.lead': '시스템에 설치할 것도 없고, 오디오 경로를 마련할 필요도 없습니다. 회의 사이트를 겨냥해 만들어졌고, 페이지 자체에 가상 마이크를 넣을 수 있습니다.',
  'download.ext.browser': 'Chrome와 Edge',
  'download.ext.browserBody': 'Chromium 116 이상, 사이드 패널 API. 스토어에서 한 번의 클릭으로 설치됩니다.',
  'download.ext.worksOn': '지원 사이트',
  'download.ext.elsewhere': '그 밖에는 데스크톱 앱을 쓰세요',
  'download.need.title': '설치하기 전에',
  'download.need.col': '필요한 것',
  'download.need.linux': 'PulseAudio 또는 PipeWire 실행, 그리고 pactl을 위한 pulseaudio-utils',
  'download.need.windows': '오디오 경로를 위한 VB-CABLE. 설치 프로그램이 안내합니다',
  'download.need.macos': '함께 들어 있는 SokujiVirtualAudio 드라이버',
  'download.need.any': '어느 플랫폼이든',
  'download.need.anyBody': '제공자 하나: 온디바이스 추론, 자기 API 키, 또는 Kizuna AI 계정. 설치 자체에는 어느 것도 필요 없습니다.',
  'download.need.nothing': '아무것도',
  'download.need.nothingBody': '내려받기에도, 설치에도, 자기 키나 기기에서 Sokuji를 쓰는 데에도 계정은 필요 없습니다.',
  'download.linux.title': '리눅스',
  'download.linux.body': 'Debian 패키지 또는 AppImage, x64와 arm64. 가상 마이크는 Sokuji가 PulseAudio나 PipeWire를 통해 직접 만듭니다 — 따로 설치할 것은 없습니다.',
  'download.windows.title': '윈도우',
  'download.windows.body': '코드 서명이 되어 있어 흔한 “알 수 없는 게시자” 경고 없이 설치됩니다 — 자유 소프트웨어에 무료로 서명해 주는 SignPath Foundation 덕분입니다. 오디오 경로는 VB-CABLE을 지납니다.',
  'download.macos.title': 'macOS',
  'download.macos.body': '오디오 드라이버는 설치 프로그램 안에 들어 있습니다. 앱 자체는 서명되었고 Apple의 공증을 받아, 다른 Mac 앱과 똑같이 설치할 수 있습니다.',
  'home.platform.linux.body': '가상 마이크는 Sokuji가 PulseAudio나 PipeWire를 통해 직접 만듭니다 — 따로 설치할 것은 없습니다.',
  'home.platform.cta': '다운로드',
  'home.platform.windows.body': '코드 서명이 되어 있어 흔한 경고 없이 설치됩니다 — 무료로 서명해 주는 SignPath Foundation 덕분입니다. 오디오 경로는 VB-CABLE을 씁니다.',
  'home.platform.macos.body': '오디오 드라이버는 설치 프로그램에 함께 들어 있습니다. 앱은 서명되었고 Apple의 공증을 받아, 다른 Mac 앱과 똑같이 설치할 수 있습니다.',
  'home.faq.title': '왜 이렇게 만들었는가',
  'home.faq.lead': '받는 질문의 대부분은 사실 제품 뒤에 있는 선택에 대한 질문입니다. 여기에 그대로 답합니다.',
  'faq.audio.q': '제 오디오나 회의 내용을 가져가나요?',
  'faq.audio.a': '아니요. 오디오, 화면 이미지, 전사, 번역은 당신의 기기에서 당신이 고른 AI 제공자로 곧장 갑니다. 키가 Kizuna AI 계정에서 나올 때도 마찬가지입니다. 우리는 짧은 시간 동안만 유효한 키를 발급하고 사용량을 셀 뿐이고, 나머지는 공급자가 합니다. 보관하는 것은 계정에 필요한 정보(이메일, 로그인 기록, 잔액, 사용량)이며, 회의 내용은 절대 보관하지 않습니다. 전체 목록은 개인정보 보호 페이지에 있습니다.',
  'faq.other.q': '왜 상대는 아무것도 설치하지 않아도 되나요?',
  'faq.other.a': '언어를 건너는 일은 이해받고 싶은 쪽의 몫이지, 듣는 모든 사람의 몫이 아니라고 보기 때문입니다. Sokuji는 당신 쪽에서 번역해 가상 마이크로 말하므로, 상대에게 닿는 것은 평범한 통화 오디오입니다.',
  'faq.service.q': '저희 AI 서비스를 꼭 써야 하나요?',
  'faq.service.a': '아니요. 지원되는 어떤 공급자의 키든 직접 가져오거나, 기기에서 무료로 돌리면 됩니다. Kizuna AI 계정은 개발자 콘솔을 만지고 싶지 않은 사람들을 위한 것이지, 누구를 묶어 두려는 것이 아닙니다.',
  'faq.cost.q': 'Sokuji는 얼마인가요?',
  'faq.cost.a': 'Sokuji는 무료 오픈소스이고, 온디바이스 추론도 함께 무료입니다. 돈이 드는 것은 선택 사항인 Kizuna AI 계정뿐이며, 실제 사용량만큼 과금됩니다 — 월 구독이 아니고, 쓰지 않은 달은 0원입니다. 충전 잔액의 유효기간은 1년인데, 이 기한은 회계상의 구분이지 쓰라고 미는 장치가 아닙니다. 자기 키를 쓰거나 로컬로 돌리면 우리에게 낼 돈은 전혀 없습니다.',
  'faq.believe.q': '그 말을 왜 믿어야 하나요?',
  'faq.believe.a': '절반은 믿지 마세요 — 그래서 선을 그어 둡니다. 앱은 AGPL-3.0 라이선스이고, 오디오가 어디로 갈지 정하는 것이 바로 그 앱입니다. 전부 github.com/kizuna-ai-lab/sokuji에 있고, 직접 빌드할 수 있으며, 네트워크에서 확인할 수도 있습니다. 계정 서비스는 오픈소스가 아니므로, 계정과 사용량 데이터를 어떻게 다루는지는 증명이 아니라 약속입니다. 그 선은 흐리기보다 그어 두는 편이 낫습니다.',
  'faq.youtube.q': 'YouTube를 실시간으로 번역하는 데 쓸 수 있나요?',
  'faq.youtube.a': '가능하고, 막는 것도 없습니다 — Sokuji는 기기에 도달하는 소리라면 영상이라도 번역합니다. 다만 그걸 겨냥해 만들지는 않았습니다. 십만 명이 보는 영상을 각자 실시간 번역하면 같은 일을 십만 번 하는 셈이고, 게시자가 한 번 번역하면 한 번으로 끝납니다. 실제로 창작자들이 그 번역을 만들 때 Sokuji를 씁니다.',
  'faq.local.q': '로컬 AI는 오프라인일 때의 대체 수단일 뿐인가요?',
  'faq.local.a': '아닙니다 — 처음부터 일급 경로였고 언제나 무료였습니다. 모델은 계속 작아지고, 런타임은 계속 좋아지고, 소비자용 가속기는 계속 빨라집니다. AI를 쓰겠다는 이유만으로 자기 대화를 거대 AI 기업에 넘겨야 할 사람은 없습니다.',
  'faq.platforms.q': 'Sokuji는 macOS와 Windows에서 서명되어 있나요?',
  'faq.platforms.a': '네. Windows 설치 프로그램은 자유 소프트웨어에 무료로 서명해 주는 SignPath Foundation 덕분에 서명되어 있습니다. macOS 빌드는 버전 0.46.5부터 Apple Developer ID로 서명되고 Apple의 공증을 받습니다.',
  'home.during.title': '통화 중에 하는 일',
  'home.during.lead': '음성을 모델에 흘려보내는 건 누구나 할 수 있습니다. 회의 내내 알아들을 수 있게 유지하는 것 — 속도를 따라가고, 말이 끝났는지 판단하고, 자기 목소리를 되돌려 보내지 않는 것 — 그게 오디오 엔지니어링입니다.',
  'feat.voice.t': '자기 목소리로 말하기',
  'feat.voice.b': '짧은 클립을 한 번 녹음하면 번역된 발화가 기성 음색이 아니라 당신의 목소리로 전달됩니다. 제공자의 음색 라이브러리에서 고를 수도 있습니다. 고를 수 있는 음색은 쓰는 제공자에 따라 다릅니다.',
  'feat.tempo.t': '말 속도 자동 조절',
  'feat.tempo.b': '같은 문장도 언어마다 길이가 달라, 고정 속도로는 문장마다 번역이 뒤처집니다. Sokuji는 따라잡을 만큼만 속도를 올립니다.',
  'feat.turn.t': '의미 단위로 끊기',
  'feat.turn.b': '단순한 멈춤이 아니라 생각이 끝난 지점을 기다립니다. 문장 중간에 잘리지 않습니다.',
  'feat.terms.t': '당신의 말, 당신의 용어',
  'feat.terms.b': '시스템 지시로 이름, 제품명, 사내 용어가 뭉개진 번역이 되는 걸 막습니다.',
  'feat.overlay.t': '자막 오버레이',
  'feat.overlay.b': '끌고 크기를 바꿀 수 있는 별도 창이거나, 회의 페이지 위에 얹는 자막이거나.',
  'feat.offline.t': '네트워크를 꺼도 동작',
  'feat.offline.b': 'Sokuji가 GPU를 감지해 그에 맞는 추론 엔진을 내려받고, 인식·번역·합성을 당신의 기기에서 수행합니다. 키도 계정도 계측도 없습니다. 여기서 온디바이스는 일급 경로이지, 연결이 끊겼을 때의 대체 수단이 아닙니다.',
  'home.during.also': '그 밖에: 누르는 동안만 번역, 잡음 억제, 에코 제거, 중간 전사 번역, 오디오 버퍼 조정, 세션 중 오디오 장치 전환, 가상 마이크 자체, 대화를 .txt 또는 .json으로 내보내기.',
  'home.carry.title': '저희가 짊어지는 것과, 당신에게 남는 것',
  'home.carry.lead': 'Sokuji는 무료이고 오픈 소스이며 앞으로도 그렇습니다. 그와 별개로 Kizuna AI 계정은 몇몇 AI 업체에 대해 키를 보관하고 대금을 정산해 줍니다 — 개발자 콘솔을 만지고 싶지 않은 분들을 위해서요. 모델을 돌리는 건 저희가 아니고, 한 번도 쓰지 않으셔도 되는 서비스입니다. 모든 편의 옆에는 출구가 있습니다.',
  'carry.ours': '이건 저희가 짊어집니다',
  'carry.yours': '이건 언제든 직접 하실 수 있습니다',
  'carry.account.t': '계정 하나, 콘솔 없이',
  'carry.account.b': '저희가 자격 증명을 발급하고 대금을 정산합니다. 모델은 여전히 Soniox 또는 Qwen이 돌립니다.',
  'carry.bill.t': '청구서 하나, 사용량 기준',
  'carry.bill.b': '결제 배관은 저희가 맡고, 실제로 쓰신 만큼만 청구합니다.',
  'carry.cloud.t': '필요할 때 클라우드 모델',
  'carry.cloud.b': '오늘 기준 가장 빠르고 정확한 번역을, 필요할 때만.',
  'carry.packaged.t': '패키징된 앱',
  'carry.packaged.b': '데스크톱 빌드와 브라우저 확장을 몇 번의 클릭으로.',
  'carry.ownkey.t': '자기 키 쓰기',
  'carry.ownkey.b': '열 곳 넘는 제공자를 지원하며, 각각 스크린샷이 있는 안내가 있습니다.',
  'carry.direct.t': '제공자에게 직접 결제',
  'carry.direct.b': '저희를 완전히 빼셔도 됩니다. Kizuna AI 계정 없이도 Sokuji는 동작합니다.',
  'carry.machine.t': '자기 기기에서 돌리기',
  'carry.machine.b': '온디바이스 추론. 무료이고 오프라인에서 동작하며 첫 선택지로 함께 제공됩니다.',
  'carry.source.t': '소스에서 빌드하기',
  'carry.source.b': '복제하고, 읽고, 고치고, 자기 빌드를 배포하세요. AGPL-3.0입니다.',
  'stat.langs': '번역 언어',
  'stat.ui': '인터페이스 언어',
  'stat.sites': '확장 프로그램이 지원하는 회의 사이트',
  'stat.providers': 'AI 제공자, 직접 만든 엔드포인트도 가능',
  'home.platforms.title': '모든 플랫폼, 그리고 각 플랫폼이 요구하는 것',
  'download.builds': '빌드',
  'download.readGuide': '설치 가이드 보기',
  'home.install.flowLabel': '번역된 당신의 목소리가 가상 마이크를 지나 상대에게 닿는 경로',
  'home.routing.title': '당신의 회의 내용은 저희를 거치지 않습니다',
  'home.routing.lead': 'Kizuna AI 계정의 키를 쓰더라도 오디오, 화면 이미지, 번역은 당신의 기기에서 모델을 돌리는 업체로 곧장 갑니다. 고른 모델이 기기 내장형이라면 아예 어디로도 나가지 않습니다. 저희가 하는 일은 계정 관리와 과금뿐이고, 보관하는 것은 계정과 사용량 데이터이며 회의 내용은 절대 보관하지 않습니다.',
  'routing.you': '당신',
  'routing.sokuji': 'sokuji(당신의 기기에서)',
  'routing.provider': '당신이 고른 AI 제공자',
  'routing.providerNote': '클라우드 또는 당신의 기기',
  'routing.up': '당신의 오디오(올라감)',
  'routing.down': '번역(돌아옴)',
  'routing.onDevice': '기기 내장: 둘 다 여기서 나가지 않음',
  'routing.mic': '가상 마이크',
  'routing.app': '임의의 앱',
  'routing.them': '상대',
  'routing.kizuna': 'Kizuna AI',
  'routing.kizunaCarries': '단기 키 · 사용량 과금 · 회의 내용 없음',
  'routing.label': '회의 내용은 당신의 기기와 고른 제공자 사이를 오가고, Kizuna AI는 키, 당신의 계정, 사용량만 나르는 별도 가지에 있습니다',
  'routing.or': '또는',
  'scenarios.page.title': '무엇을 하려고 하시나요?',
  'scenarios.page.lead': '이건 프리셋이지 당신을 가두는 모드가 아닙니다. 설정되는 항목은 모두 나중에 바꿀 수 있습니다.',
  'scenarios.axes.title': '각 프리셋이 정하는 것',
  'scenarios.axes.lead': '다섯 가지 모두 같은 세 가지 결정에 다르게 답한 것입니다. 누구의 오디오를 번역할지, 그 결과를 소리 내어 말할지, 그리고 화면에 무엇이 남을지.',
  'axis.sets': '이 프리셋이 정하는 것',
  'scenarios.whoPicks': '누가 고르나:',
  'scenarios.anyApp.lead': '“임의의 앱”은 말 그대로입니다.',
  'scenarios.anyApp.body': '나가는 쪽에서 Sokuji는 평범한 마이크이므로, 마이크를 고를 수 있는 것이라면 무엇이든 번역된 목소리를 실어 나릅니다 — 브라우저 탭, 녹음기, 방송 소프트웨어, 게임. 들어오는 쪽에서는 기기가 재생하는 모든 것, 시스템 오디오까지 다루므로 영상도 방송도 녹화도 통화와 똑같이 동작합니다.',
  'scenarios.fit.title': '모든 제공자가 모든 시나리오를 해내지는 않습니다',
  'scenarios.fit.lead': '핵심은 두 가지입니다. 첫째는 그 제공자가 목소리를 낼 수 있는지, 그리고 조용히 있게 할 수 있는지입니다. 텍스트만 돌려주는 곳은 통화에 말해 줄 수 없고, 늘 오디오로 답하는 곳은 자막만으로 묶어 둘 수 없습니다. 지금 Sokuji가 제공하는 제공자는 모두 둘 다 되지만, 이 확인은 다음 제공자를 위해 남겨 둡니다. 둘째는 마주 보고 대화입니다. 두 사람이 마이크 하나를 쓰려면 화자를 구별할 수 있는 제공자가 필요하고, 그게 되는 건 Soniox뿐입니다(자기 키로, 또는 KizunaAI를 통해). Sokuji는 제공자를 고를 때 이 두 가지를 확인하므로, 감당 못 하는 시나리오는 통화 중에 발견되는 대신 그 전에 닫힙니다.',
  'scenarios.fit.available': '가능',
  'scenarios.fit.unavailable': '그 제공자로는 불가',
  'scenarios.fit.note': "“상대방의 말 이해하기”만은 어디서나 됩니다. 처음엔 텍스트로 시작하고, 상대 쪽은 '내가 듣는 번역'을 켤 때만 소리 내어 읽습니다. 마지막 열은 Soniox입니다(자기 키로, 또는 KizunaAI를 통해).",
  'provider.textOnly': '텍스트만\n반환',
  'provider.alwaysSpeaks': '항상\n말함',
  'provider.either': '둘 다\n가능',
  'provider.faceToFace': '둘 다 가능,\n마주 보고도',
  'spoken.yesVoice': '예 — 합성 음성을 통화로 보냅니다',
  'spoken.yesBoth': '예 — 당신 쪽은 통화로, 상대 쪽은 당신에게',
  'spoken.yesEarbuds': '예 — 각자 이어버드 한쪽으로 상대의 번역을 듣습니다',
  'spoken.optional': "아니오 — '내가 듣는 번역'을 켜지 않는 한",
  'flow.you': '당신',
  'flow.subtitles': '자막',
  'flow.anyAppSystem': '임의의 앱\n또는 시스템 오디오',
  'flow.yourHeadphones': '당신의 헤드폰',
  'flow.yourEarbud': '당신의 이어버드',
  'flow.theirEarbud': '상대의 이어버드',
  'flow.sameScreen': '같은 화면',
  'scenario.understand-others.who': '당신이 듣는 쪽이고, 말하는 사람이 맞춰 줄 리는 없을 때.',
  'scenario.be-heard.who': '그 자리의 공통어가 아닌 언어로 말하는 사람. 게다가 그 통화를 만든 사람이 당신이 아닐 수도 있을 때.',
  'scenario.subtitle-myself.who': '발표자와 스트리머. 자기 목소리 위에 또 다른 목소리가 겹치는 것보다 자막이 나은 자리.',
  'scenario.two-way-voice.who': '어느 쪽도 공통의 언어가 없는, 진짜 주고받는 대화.',
  'scenario.two-way-text.who': '녹화되는 회의, 회의록 작성, 또는 소리를 더하는 것이 반갑지 않은 자리.',
  'scenario.face-to-face-voice.who': '같은 방에 있지만 공통 언어가 없는 두 사람 — 책상에서, 창구에서, 식탁에서.',
  'scenario.face-to-face-text.who': '같은 방에서 귀에 목소리가 더해지는 게 반갑지 않을 때, 또는 상대가 자기 휴대폰으로 읽고 싶을 때.',
  'axis.whoseAudio': '누구의 음성',
  'axis.spokenAloud': '소리로 냄',
  'axis.onScreen': '화면에 표시',
  'audio.speaker': '당신의 마이크',
  'audio.participant': '상대 쪽',
  'audio.both': '양쪽',
  'audio.besideMe': '두 사람 모두, 마이크 하나로',
  'spoken.yes': '예',
  'spoken.no': '아니오',
  'scenario.understand-others.onScreen': '상대 발언의 번역',
  'scenario.understand-others.flow': '상대가 말함 → 당신이 읽음',
  'scenario.be-heard.onScreen': '당신의 말과 번역을 나란히',
  'scenario.be-heard.flow': '당신이 말함 → 상대가 들음',
  'scenario.subtitle-myself.onScreen': '번역문, 청중용',
  'scenario.subtitle-myself.flow': '당신이 말함 → 상대가 읽음',
  'scenario.two-way-voice.onScreen': '원문과 번역, 양쪽 모두',
  'scenario.two-way-voice.flow': '양방향 · 양쪽 모두 음성',
  'scenario.two-way-text.onScreen': '원문과 번역, 양쪽 모두',
  'scenario.two-way-text.flow': '양방향 · 텍스트만',
  'scenario.face-to-face-voice.onScreen': '양쪽 모두, 줄마다 어느 귀로 재생되는지 표시',
  'scenario.face-to-face-voice.flow': '마이크 하나 · 이어버드 한쪽씩',
  'scenario.face-to-face-text.onScreen': '원문과 번역, 양쪽 모두',
  'scenario.face-to-face-text.flow': '마이크 하나 · 텍스트만',
  'scenario.understand-others.title': '상대방의 말 이해하기',
  'scenario.understand-others.body': '온라인 회의, 수업, 강연, 영상, 스트리밍 — 듣는 내용을 실시간 번역으로 읽습니다.',
  'scenario.understand-others.detail': "온라인 회의, 수업, 강연, 영상, 스트리밍 — 듣는 내용을 실시간 번역으로 읽습니다. '내가 듣는 번역'을 켜지 않으면 소리 내어 읽지 않습니다.",
  'scenario.be-heard.title': '회의에서 내 말 전달하기',
  'scenario.be-heard.body': '상대방은 가상 마이크를 통해 번역된 내 목소리를 듣습니다.',
  'scenario.be-heard.detail': '상대방은 가상 마이크를 통해 번역된 내 목소리를 듣습니다. 상대 쪽은 설치도, 플러그인도, 읽을 자막도 필요 없습니다.',
  'scenario.subtitle-myself.title': '내 말에 자막 달기',
  'scenario.subtitle-myself.body': '강연, 스트리밍, 발표 — 청중이 번역된 자막을 읽습니다. 음성은 생성되지 않습니다.',
  'scenario.subtitle-myself.detail': '강연, 스트리밍, 발표 — 청중이 번역된 자막을 읽습니다. 음성은 생성되지 않습니다. 당신은 자기 목소리로 계속 말합니다.',
  'scenario.two-way-voice.title': '양방향 온라인 대화',
  'scenario.two-way-voice.body': '상대방은 번역된 내 목소리를 듣고, 나는 상대방의 자막을 읽으며 번역 음성도 들을 수 있습니다.',
  'scenario.two-way-voice.detail': "상대방은 번역된 내 목소리를 듣고, 나는 상대방의 자막을 읽으며 번역 음성도 들을 수 있습니다. 데스크톱 앱에서는 '상대방 오디오'가 하나의 애플리케이션(예: 회의 앱)일 때 상대의 번역을 읽어 줍니다. 시스템 전체 소리를 캡처할 때는 자막으로만 읽습니다.",
  'scenario.two-way-text.title': '양방향 온라인 대화, 자막만',
  'scenario.two-way-text.body': '이중 언어 자막, 회의록 — 양쪽 모두 텍스트로, 합성 음성 없음.',
  'scenario.two-way-text.detail': '이중 언어 자막, 회의록 — 양쪽 모두 텍스트로, 합성 음성 없음.',
  'scenario.face-to-face-voice.title': '마주 보고 대화',
  'scenario.face-to-face-voice.body': '한 대의 컴퓨터 앞에서 두 사람이 각자의 언어로 말합니다. 각자 이어버드를 한쪽씩 끼고 자기 언어로 된 번역만 듣습니다.',
  'scenario.face-to-face-voice.detail': '한 대의 컴퓨터 앞에서 두 사람이 각자의 언어로 말합니다. 각자 이어버드를 한쪽씩 끼고 자기 언어로 된 번역만 듣습니다. 기본값으로 당신의 이어버드가 왼쪽 채널, 상대의 이어버드가 오른쪽 채널입니다.',
  'scenario.face-to-face-text.title': '마주 보고 대화, 자막만',
  'scenario.face-to-face-text.body': '둘이 같은 화면을 보거나, 상대방이 휴대폰으로 LAN 자막 페이지를 엽니다.',
  'scenario.face-to-face-text.detail': '둘이 같은 화면을 보거나, 상대방이 휴대폰으로 LAN 자막 페이지를 엽니다. LAN 자막 페이지는 데스크톱 앱에만 있습니다.',
  'nav.install': '설치',
  'nav.platforms': '플랫폼',
  'nav.platformsOverview': '개요',
  'nav.aiProviders': 'AI 제공자',
  'nav.kizunaAI': 'KizunaAI',
  'nav.kizunaAIFeatures': 'KizunaAI 기능',
  'nav.providersOverview': '개요',
  'nav.privacy': '개인정보 보호',
  'nav.terms': '이용약관',
  'footer.terms': '약관',
  'nav.commerce': '상거래 정보 공개',
  'nav.feedback': '피드백',
  'nav.github': 'GitHub',

  // Tutorials
  'tutorials.zoom': 'Zoom',
  'tutorials.googleMeet': 'Google Meet',
  'tutorials.teams': 'Microsoft Teams',
  'tutorials.discord': 'Discord',
  'tutorials.slack': 'Slack',
  'tutorials.jitsi': 'Jitsi Meet',
  'tutorials.whereby': 'Whereby',
  'tutorials.gather': 'Gather',
  'tutorials.openai': 'OpenAI 설정',
  'tutorials.gemini': 'Gemini 설정',
  'tutorials.palabraai': 'PalabraAI 설정',
  'tutorials.volcengineAST2': 'Doubao AST 2.0 설정',
  'tutorials.soniox': 'Soniox 설정',
  'tutorials.qwen': 'Qwen LiveTranslate 설정',
  'tutorials.kizunaQuickStart': '빠른 시작',
  'tutorials.twoWayMeeting': '양방향 회의 번역',
  'tutorials.understandOthers': '회의·동영상 이해하기',
  'tutorials.beUnderstood': '회의에서 말하기',
  'tutorials.subtitleMySpeech': '강연·방송 자막',
  'tutorials.twoWaySubtitles': '양방향 자막',
  'tutorials.faceToFace': '마주 보고 대화',
  'tutorials.kizunaVoices': '음성과 음성 복제',
  'tutorials.kizunaVocabulary': '맞춤 어휘',
  'tutorials.kizunaRegion': '처리 지역',
  'tutorials.kizunaLatency': '문장 끊기와 지연',
  'tutorials.kizunaBilling': '잔액과 비용',
  'tutorials.localInference': '무료 (기기에서 실행) 설정',
  'tutorials.localModels': '로컬 모델과 라이선스',
  'tutorials.realtimeTester': 'API 테스터',

  // Landing Page
  'landing.title': 'Sokuji',
  'landing.slogan.line1': '자신의 언어로 말하세요.',
  'landing.slogan.line2': '상대의 언어로 전해집니다.',
  'landing.tagline': 'AI 기반 실시간 음성 번역',
  'landing.subtitle': '당신의 목소리는 상대의 언어로 나가고, 상대가 하는 말은 당신의 언어로 돌아옵니다 — 자막으로, 또는 읽어 주는 목소리로. Sokuji는 당신과 회의 앱 사이에 놓인 가상 마이크라서 설정은 당신 쪽에만 있습니다 — 상대는 평소처럼 말하면 되고, 설치할 것도 참여할 링크도 없습니다.',
  'landing.trust': '무료 오픈소스 · 온디바이스 AI · 구독 없음',
  'landing.cta.extension': '브라우저 확장 프로그램 받기',
  'landing.cta.desktop': '무료 다운로드',
  'landing.cta.docs': '문서 보기',

  // Platform Selection
  'platform.title': '플랫폼 선택',
  'platform.extension.title': '브라우저 확장 프로그램',
  'platform.extension.desc': '온라인 회의용 (Google Meet, Zoom, Teams 등)',
  'platform.extension.chrome': 'Chrome 웹 스토어',
  'platform.extension.edge': 'Edge 애드온',
  'platform.extension.brave': 'Brave (준비 중)',
  'platform.desktop.title': '데스크톱 애플리케이션',
  'platform.desktop.desc': '모든 시나리오에 적합 - 모든 웹사이트, 앱 또는 시스템 오디오',
  'platform.desktop.windows': 'Windows 설치 프로그램 (.exe)',
  'platform.desktop.macos.arm': 'macOS 설치 프로그램 - Apple Silicon (-arm64.pkg)',
  'platform.desktop.macos.intel': 'macOS 설치 프로그램 - Intel (-x64.pkg)',
  'platform.desktop.linux': 'Linux 패키지 (.deb)',

  // Installation Guides
  'install.title': '설치 가이드',
  'install.windows': 'Windows 설치 가이드',
  'install.macos': 'macOS 설치 가이드',
  'install.linux': 'Linux 설치 가이드',

  // Docs Home
  'docs.title': '문서',
  'docs.subtitle': 'Sokuji 설치 및 사용 방법 알아보기',
  'docs.gettingStarted': '시작하기',
  'docs.installation': '설치',
  'docs.configuration': '설정',
  'docs.resources': '리소스',
  'docs.card.participantAudio': '상대방이 하는 말을 번역합니다. 회의 앱, 브라우저 탭 또는 시스템 전체 오디오에서 가져옵니다.',
  'docs.card.subtitleMode': '회의, 동영상, 슬라이드 위에 띄워 둘 수 있는 얇은 자막 바.',

  // Supported Sites
  'sites.title': '지원되는 웹사이트',
  'sites.subtitle': 'Sokuji 확장 프로그램은 다음 화상 회의 및 커뮤니케이션 플랫폼과 호환됩니다.',
  'sites.howToUse.title': '사용 방법',
  'sites.howToUse.desc': '지원되는 플랫폼에서 플랫폼의 오디오 설정에서 마이크 입력으로 "Sokuji Virtual Microphone"을 선택하기만 하면 됩니다. Sokuji가 음성을 실시간으로 번역합니다.',
  'sites.needHelp.title': '도움이 필요하신가요?',
  'sites.needHelp.desc': '특정 플랫폼에서 문제가 발생하면 GitHub 저장소에서 문제 해결 가이드와 지원을 확인하세요.',
  'sites.visitPlatform': '플랫폼 방문',
  'sites.tutorial': '튜토리얼',

  // Site Cards
  'sites.meet.name': 'Google Meet',
  'sites.meet.url': 'meet.google.com',
  'sites.meet.features': '',

  'sites.teams.name': 'Microsoft Teams',
  'sites.teams.url': 'teams.live.com / teams.microsoft.com',
  'sites.teams.features': '크로스 플랫폼 호환성|개인용 및 기업용 버전',

  'sites.gather.name': 'Gather',
  'sites.gather.url': 'app.gather.town',
  'sites.gather.features': '공간 오디오 지원',

  'sites.whereby.name': 'Whereby',
  'sites.whereby.url': 'whereby.com',
  'sites.whereby.features': '브라우저 기반 회의',

  'sites.discord.name': 'Discord',
  'sites.discord.url': 'discord.com',
  'sites.discord.features': '음성 채널 지원',

  'sites.slack.name': 'Slack',
  'sites.slack.url': 'app.slack.com',
  'sites.slack.features': 'Huddles 및 통화 지원',

  'sites.jitsi.name': 'Jitsi Meet',
  'sites.jitsi.url': 'meet.jit.si',
  'sites.jitsi.features': '오픈소스 회의 지원',

  'sites.zoom.name': 'Zoom',
  'sites.zoom.url': 'app.zoom.us',
  'sites.zoom.features': '웹 클라이언트 지원',

  // AI Providers
  'providers.title': '지원되는 AI 제공자',
  'providers.subtitle': 'Sokuji는 실시간 음성 번역을 위해 여러 AI 제공자를 지원합니다. 각 제공자는 다양한 기능, 모델 및 가격 구조를 제공합니다. 무료 모드는 API 키 없이 기기에서 무료로 작동합니다(인터넷 연결이 필요한 것은 일부 음성뿐입니다).',
  'providers.setup.title': '설정 지침',
  'providers.setup.desc': '클라우드 AI 제공자를 사용하려면 제공자 웹사이트에서 API 키를 받아 Sokuji 설정 패널에서 구성하세요. 무료 모드는 API 키 불필요 — 모델을 다운로드하면 바로 번역을 시작할 수 있습니다.',
  'providers.choosing.title': '제공자 선택',
  'providers.needHelp.title': '도움이 필요하신가요?',
  'providers.needHelp.desc': '설정 가이드, 문제 해결 및 제공자 비교는 GitHub 저장소를 방문하세요.',
  'providers.docs': '문서',
  'providers.setupTutorial': '설정 튜토리얼',

  // Provider Cards
  'providers.openai.name': 'OpenAI',
  'providers.openai.type': '실시간 오디오 API',
  'providers.openai.features': 'GPT-4o Realtime Preview 모델|8가지 프리미엄 음성 옵션|고급 턴 감지 모드|내장 노이즈 감소|60개 이상의 언어 지원|맞춤 프롬프트용 템플릿 모드',
  'providers.openai.desc': '고품질 음성 합성 및 고급 기능에 최적',

  'providers.gemini.name': 'Google Gemini',
  'providers.gemini.type': 'Gemini Live API',
  'providers.gemini.features': 'Gemini 2.0 Flash Live 모델|30가지 고유한 음성 개성|자동 턴 감지|35개 이상의 언어와 지역 변형|내장 전사|높은 토큰 제한 (8192)',
  'providers.gemini.desc': '다국어 지원 및 자동 처리에 적합',

  'providers.palabra.name': 'PalabraAI',
  'providers.palabra.type': 'WebRTC 번역 서비스',
  'providers.palabra.features': '실시간 WebRTC 번역|60개 이상의 소스 언어|40개 이상의 대상 언어|저지연 스트리밍|자동 오디오 처리|라이브 번역에 특화',
  'providers.palabra.desc': '최소 지연으로 실시간 번역에 최적화',



  'providers.volcengineAST2.name': 'Doubao AST 2.0',
  'providers.volcengineAST2.type': '음성 대 음성 번역',
  'providers.volcengineAST2.features': '엔드투엔드 음성 대 음성 번역|음성 복제, 또는 500개 이상의 라이브러리에서 고른 고정 음성|낮은 지연 시간의 동시 통역|20개 언어와 광둥어·우어, 그중 8개는 음성 출력|App ID + Access Token 또는 API 키|ByteDance 클라우드 인프라',
  'providers.volcengineAST2.desc': '화자의 목소리를 복제하거나 직접 고른 고정 음성으로 말하는 Doubao의 음성 대 음성 동시 통역',
  'providers.soniox.name': 'Soniox',
  'providers.soniox.type': '음성 대 음성 번역',
  'providers.soniox.features': '실시간 음성 대 음성 번역|단일 API 호출로 60개 이상 언어 전사 및 번역|자동 언어 감지|200개 내장 음성 및 음성 복제|음성 번역 또는 자막 전용|대면 대화 및 화자 라벨|Soniox 클라우드 인프라',
  'providers.soniox.desc': '자동 언어 감지 기능을 갖춘 60개 이상 언어의 Soniox 실시간 음성 대 음성 번역',

  'providers.qwen.name': 'Qwen LiveTranslate',
  'providers.qwen.type': '음성 대 음성 통역',
  'providers.qwen.features': '하나의 스트리밍 세션에서 이루어지는 실시간 동시 통역(qwen3.8-livetranslate-flash-realtime)|60개 언어, 그중 29개는 음성 출력, 소스 언어 자동 감지|47개의 기본 제공 음성, 또는 녹음 없이 실시간으로 복제하는 내 목소리|이름과 용어에 대한 선호하는 번역|음성 번역 또는 자막 전용|QwenCloud(국제) 또는 千问云(중국 본토)에서 발급받은 내 키, 또는 Kizuna AI 계정|알리바바 클라우드 인프라; 데스크톱 앱과 브라우저 확장 프로그램',
  'providers.qwen.desc': '60개 언어에서 실시간으로 복제한 내 목소리로 말할 수 있는 동시 통역',

  'providers.localInference.name': '무료',
  'providers.localInference.type': '온디바이스 AI (엣지)',
  'providers.localInference.features': '완전 오프라인 — API 키나 인터넷 불필요|40개 이상 ASR 모델로 99개 이상 언어 지원|55개 이상 번역 언어 쌍 + Qwen LLM|53개 언어의 136개 TTS 모델|CPU (WASM) 및 WebGPU 가속|프라이버시 최우선 — 모든 데이터가 기기에 유지',
  'providers.localInference.desc': '기기에서 모든 것을 실행하고 데이터가 기기를 벗어나지 않음 — 프라이버시에 민감한 사용 사례에 적합',

  // Privacy Policy
  'privacy.title': '개인정보 보호정책',
  'privacy.lastUpdated': '최종 업데이트: 2026년 11월 3일',
  'privacy.intro.title': '소개',
  'privacy.intro.content': '본 개인정보 보호정책은 Kizuna AI Lab("당사")이 데스크톱 애플리케이션, 모바일 애플리케이션, 브라우저 확장 프로그램, sokuji.kizuna.ai 웹사이트 및 Kizuna AI 계정을 포함한 Sokuji(이하 통칭하여 "본 서비스")와 관련하여 정보를 수집, 사용, 공개, 보존 및 보호하는 방법을 설명합니다.',
  'privacy.guarantee.title': '회의 콘텐츠',
  'privacy.guarantee.content': '회의 콘텐츠(오디오, 화면 컨텍스트를 위해 귀하가 선택한 창, 탭 또는 화면의 이미지, 전사 및 번역)는 귀하의 기기에서 귀하가 선택한 AI 제공업체로 직접 전송됩니다. 당사는 "회의 콘텐츠의 전송"에 기술된 음성 샘플 관련 예외만을 제외하고 회의 콘텐츠를 당사 서버에서 수신, 처리 또는 저장하지 않습니다. 특히 당사는 다음을 저장하지 않습니다:',
  'privacy.guarantee.items': '오디오 녹음 또는 기타 음성 콘텐츠|화면 컨텍스트를 위해 전송되는 귀하의 화면 이미지|전사, 번역 또는 기타 대화 내용',
  'privacy.collect.title': '수집하는 정보',
  'privacy.collect.content': '"계정 정보", "로그인 기록", "악용 방지 기록" 및 "과금, 사용량 및 결제 정보"에 기술된 정보는 귀하가 Kizuna AI 계정을 생성하거나 사용하는 경우에만 수집됩니다. 사용 통계 및 오류 보고는 귀하의 로그인 여부와 관계없이 데스크톱 애플리케이션, 모바일 애플리케이션, 브라우저 확장 프로그램 및 웹사이트에서 수집됩니다.',
  'privacy.account.title': '계정 정보',
  'privacy.account.content': '귀하가 Kizuna AI 계정을 생성하는 경우, 당사는 다음 정보를 수집합니다:',
  'privacy.account.items': '이메일 주소: 등록, 로그인, 계정 확인, 비밀번호 복구 및 체험 크레딧 지급에 사용됩니다.|비밀번호: 솔트가 적용된 scrypt 해시로만 저장되며, 당사가 귀하의 비밀번호를 평문으로 저장하거나 평문 비밀번호에 접근하는 일은 절대 없습니다.|표시 이름: 귀하가 가입 시 입력한 이름으로, 임의의 닉네임을 사용할 수 있습니다.|계정 생성일 및 귀하의 로그인 상태를 유지하는 데 사용되는 세션 토큰.',
  'privacy.signin.title': '로그인 기록',
  'privacy.signin.content': '귀하가 로그인할 때마다 당사는 IP 주소, 사용자 에이전트(브라우저 및 기기 유형), 그리고 IP 주소로부터 추정한 대략적인 위치(국가, 지역, 도시 및 대략적인 좌표)를 기록합니다. 당사는 이러한 기록을 귀하의 로그인 상태 유지, 귀하의 계정 보안 및 계정 문제 조사에 사용합니다.',
  'privacy.abuse.title': '악용 방지 기록',
  'privacy.abuse.content': '동일인이 체험 크레딧을 두 번 이상 받는 것을 방지하기 위해, 당사는 계정 활동과 관련된 IP 주소를 기록합니다. 또한 당사는 체험 크레딧 기록, 즉 체험 크레딧을 받은 이메일 주소의 단방향 해시 값과, 받기가 거부된 경우에는 일치한 IP 주소를 보존합니다.',
  'privacy.billing.title': '과금, 사용량 및 결제 정보',
  'privacy.billing.content': '당사는 귀하에게 요금을 청구하고 귀하에게 사용량을 표시하기 위해 귀하의 잔액, 충전 내역 및 세션별 사용량(이용 시간, 제공업체 및 리전 등)을 기록합니다. 결제는 Stripe가 처리합니다. 귀하의 전체 카드 번호는 Stripe에만 제공되며, 당사가 이를 수신하는 일은 절대 없습니다. 결제를 대조하고 확인하기 위해 당사는 Stripe로부터 결제자의 이름, 이메일 주소 및 청구지 주소, 그리고 카드 브랜드 및 마지막 4자리 등 일부 결제 정보를 받습니다.',
  'privacy.collect.analytics.title': '사용 통계 및 오류 보고',
  'privacy.collect.analytics.content': '당사는 미국에 소재한 PostHog를 사용하여 다음을 포함한 사용 통계 및 오류 보고를 수집합니다:',
  'privacy.collect.analytics.items': '사용한 기능, 선택한 AI 제공업체 및 세션 시간|오류, 오류 보고 및 성능 측정값|기기, 운영 체제 및 브라우저 유형|언어 선택|브라우저 확장 프로그램에서, 귀하가 확장 프로그램을 여는 페이지의 웹사이트 주소(호스트 이름)',
  'privacy.collect.analytics.identity': '귀하가 로그인한 경우, 이 정보는 귀하의 계정 ID, 이메일 주소 및 표시 이름과 연결됩니다. 이 정보에는 회의 콘텐츠가 포함되지 않습니다. 본 서비스는 현재 사용 통계를 비활성화하는 앱 내 설정을 제공하지 않습니다. 귀하는 "귀하의 권리"에 기술된 바에 따라 귀하의 사용 통계 데이터 삭제를 요청할 수 있습니다.',
  'privacy.feedback.title': '피드백 및 문의',
  'privacy.feedback.content': '귀하가 피드백을 보내거나 당사에 연락하는 경우, 당사는 귀하의 메시지 내용, 귀하의 이메일 주소 및 메시지에 첨부된 기술 정보(예: 귀하의 브라우저 사용자 에이전트, 애플리케이션 버전 및 기기 모델, 그리고 귀하가 로그인한 경우 귀하의 계정 ID)를 수신합니다.',
  'privacy.localOnly.title': '귀하의 기기에 저장되는 정보',
  'privacy.localOnly.content': '다음 정보는 귀하의 기기에 저장되며 당사 서버로 전송되지 않습니다:',
  'privacy.localOnly.items': '설정 및 귀하 자신의 API 키: 데스크톱 애플리케이션은 이를 귀하의 컴퓨터에 로컬로 저장합니다. 모바일 애플리케이션은 귀하의 설정을 귀하의 휴대전화에 보관합니다. 브라우저 확장 프로그램은 이를 브라우저의 확장 프로그램 저장소에 저장하며, Chrome 동기화가 사용 설정된 경우 귀하의 브라우저는 Google의 개인정보 보호 약관에 따라 귀하의 Google 계정을 통해 이를 동기화합니다.|세션 기록 및 내보낸 파일.|온디바이스 모델만 사용하는 경우의 모든 회의 콘텐츠.',
  'privacy.storage.transmission.title': '회의 콘텐츠의 전송',
  'privacy.storage.transmission.content': '회의 콘텐츠는 암호화된 연결을 통해 귀하의 기기에서 귀하가 선택한 AI 제공업체로 직접 전송됩니다. 귀하가 Kizuna AI 계정을 사용하는 경우, 당사는 해당 제공업체용으로 유효 기간이 짧은 자격 증명을 발급하고 귀하의 사용량을 측정하지만, 콘텐츠 자체는 당사 서버를 거치지 않습니다. 모바일 애플리케이션은 Kizuna AI 계정을 통해 Soniox를 사용하며, 음성을 처음 전송하기 전에 귀하의 허락을 요청합니다. 귀하는 "설정 > 정보"에서 이를 철회할 수 있습니다. 로컬 추론에서 "온라인"으로 표시된 엔진(Edge TTS 및 Bing 번역기)은 온디바이스 모델이 아닙니다. 이 엔진은 사용할 수 있는 온디바이스 모델이 없을 때 자동으로 사용되며 귀하가 이를 선택할 때에도 사용되고, 이 경우 음성으로 읽거나 번역할 텍스트가 Microsoft로 전송됩니다. 예외: 귀하가 Kizuna AI 계정으로 복제 음성을 생성하는 경우, 귀하가 녹음한 음성 샘플은 해당 음성을 생성하기 위해 당사 서버를 거쳐 Soniox로 전송됩니다. 당사는 음성 샘플을 저장하지 않으며, Soniox가 반환한 음성 식별자만 보존합니다. 이 음성 식별자는 귀하가 해당 음성 또는 귀하의 계정을 삭제하면 삭제됩니다.',
  'privacy.use.title': '정보 사용 방법',
  'privacy.use.items': '본 서비스 및 귀하의 계정 제공, 운영 및 유지|제공업체 자격 증명 발급, 사용량 측정 및 귀하에 대한 요금 청구|결제 확인|체험 크레딧 악용 방지|계정 보안 및 문제 조사|본 서비스의 이용 방식 파악 및 개선|귀하의 피드백 및 요청에 대한 응답|법적 의무 준수',
  'privacy.thirdParty.title': '제3자 서비스',
  'privacy.thirdParty.content': '다음 제3자는 본 서비스와 관련하여 정보를 수신합니다. 각 제3자는 자체 개인정보 보호 약관에 따라 이를 처리합니다.',
  'privacy.thirdParty.cloudflare.title': 'Cloudflare',
  'privacy.thirdParty.cloudflare.content': '당사는 웹사이트 호스팅, 콘텐츠 전달, 당사의 계정 및 과금 데이터베이스(Cloudflare D1) 및 트랜잭션 이메일을 위해 Cloudflare를 사용합니다.',
  'privacy.thirdParty.zoho.title': 'Zoho',
  'privacy.thirdParty.zoho.content': '당사의 이메일 주소(support@kizuna.ai, privacy@kizuna.ai 및 contact@kizuna.ai 포함)는 Zoho가 호스팅합니다. 귀하가 당사에 보내는 피드백과 메시지는 Zoho의 개인정보 보호 약관에 따라 해당 메일함에 저장됩니다.',
  'privacy.thirdParty.stripe.title': 'Stripe',
  'privacy.thirdParty.stripe.content': 'Stripe는 충전 결제를 처리합니다. Stripe는 Stripe의 개인정보 보호정책에 따라 귀하의 결제 세부 정보를 수신하며, "과금, 사용량 및 결제 정보"에 기술된 결제 정보를 당사에 제공합니다.',
  'privacy.thirdParty.posthog.title': 'PostHog',
  'privacy.thirdParty.posthog.content': '미국에 소재한 PostHog는 "사용 통계 및 오류 보고"에 기술된 사용 통계 및 오류 보고를 수신합니다.',
  'privacy.thirdParty.soniox.title': 'Soniox',
  'privacy.thirdParty.soniox.content': 'Soniox를 사용하면 자체 API 키를 쓰든 Kizuna AI 계정을 통하든, 오디오와, 음성 출력 시에는 음성으로 읽을 텍스트가 사용자가 선택한 리전(미국, 유럽 연합 또는 일본)의 Soniox 서버로 전송되어 Soniox의 개인정보 보호정책에 따라 처리됩니다.',
  'privacy.thirdParty.alibaba.title': '알리바바 클라우드 (Qwen)',
  'privacy.thirdParty.alibaba.content': 'Qwen LiveTranslate를 사용하면 오디오와, 화면 컨텍스트가 켜져 있으면 내가 고른 창, 탭 또는 화면 하나의 이미지가 알리바바 클라우드 Qwen 서비스로 전송됩니다. 내 API 키를 쓰면 키를 만든 지역(싱가포르 또는 중국 본토의 베이징 중 키가 속한 곳)으로 전송되어, 키를 발급한 서비스(QwenCloud 또는 千问云)의 약관에 따라 처리됩니다. Kizuna AI 계정을 통해 쓰면 Sokuji에서 고른 지역(싱가포르 또는 베이징)으로 전송되어, 알리바바 클라우드의 개인정보 보호정책에 따라 처리됩니다.',
  'privacy.thirdParty.openai.title': 'OpenAI',
  'privacy.thirdParty.openai.content': '귀하가 OpenAI 제공업체를 사용하는 경우, 오디오 및 관련 텍스트는 OpenAI로 전송되어 OpenAI의 개인정보 보호정책에 따라 처리됩니다.',
  'privacy.thirdParty.google.title': 'Google (Gemini)',
  'privacy.thirdParty.google.content': '귀하가 Gemini를 사용하는 경우, 오디오 및 관련 텍스트는 Google로 전송되어 Google의 개인정보 보호 약관에 따라 처리됩니다.',
  'privacy.thirdParty.palabra.title': 'Palabra',
  'privacy.thirdParty.palabra.content': '귀하가 Palabra를 사용하는 경우, 오디오 및 관련 텍스트는 Palabra로 전송되어 Palabra의 개인정보 보호정책에 따라 처리됩니다.',
  'privacy.thirdParty.bytedance.title': 'ByteDance (Volcengine)',
  'privacy.thirdParty.bytedance.content': '귀하가 Volcengine 음성 번역(Doubao)을 사용하는 경우, 오디오 및 관련 텍스트는 ByteDance의 Volcengine 서비스로 전송되어 Volcengine의 개인정보 보호 약관에 따라 처리됩니다.',
  'privacy.thirdParty.microsoft.title': 'Microsoft',
  'privacy.thirdParty.microsoft.content': '로컬 추론의 Edge TTS 및 Bing 번역기는 사용할 수 있는 온디바이스 모델이 없을 때 자동으로 사용되며, 귀하가 이를 선택할 때에도 사용됩니다. 이들이 사용되는 경우, 음성으로 읽거나 번역할 텍스트는 Microsoft로 전송되어 Microsoft의 개인정보 보호 약관에 따라 처리됩니다.',
  'privacy.thirdParty.huggingface.title': 'Hugging Face',
  'privacy.thirdParty.huggingface.content': '귀하가 온디바이스 모델을 다운로드하는 경우, 파일은 Hugging Face에서 가져오며, Hugging Face는 자체 개인정보 보호정책에 따라 귀하의 IP 주소 및 요청 정보를 수신합니다.',
  'privacy.thirdParty.github.title': 'GitHub',
  'privacy.thirdParty.github.content': '데스크톱 애플리케이션은 GitHub에서 업데이트를 확인하고 GitHub에서 릴리스를 다운로드하며, GitHub는 GitHub의 개인정보 보호 약관에 따라 귀하의 IP 주소 및 요청 정보를 수신합니다.',
  'privacy.transfer.title': '국외 이전',
  'privacy.transfer.content': '위의 제3자는 미국, 유럽 연합, 일본, 싱가포르, 그리고 중국 본토(귀하가 Qwen에 대해 베이징 리전을 선택하거나 Volcengine을 사용하는 경우)를 포함한 여러 국가에서 정보를 처리합니다. 본 서비스를 이용함으로써 귀하는 귀하의 정보가 이러한 국가로 이전되어 그곳에서 처리될 수 있음을 이해합니다.',
  'privacy.storage.title': '데이터 저장 및 보안',
  'privacy.storage.content': '계정, 로그인, 과금 및 사용량 정보는 Cloudflare D1에 저장되며, Cloudflare D1은 저장된 데이터를 AES-256을 사용하여 저장 시 암호화합니다. 정보는 암호화된(TLS) 연결을 통해 전송됩니다.',
  'privacy.retention.title': '데이터 보존',
  'privacy.retention.content': '당사는 다음 기간 동안 정보를 보존합니다:',
  'privacy.retention.items': '계정 정보 및 로그인 기록: 귀하의 계정이 삭제될 때까지.|악용 방지용 IP 기록: 해당 IP 주소가 마지막으로 확인된 후 90일.|체험 크레딧 기록(이메일 주소의 단방향 해시 값과, 받기가 거부된 경우 일치한 IP 주소): 체험 크레딧을 다시 받는 것을 방지하기 위해 계정 삭제 후에도 보존.|과금 및 사용량 기록(Stripe로부터 받은 결제 정보 포함): 귀하의 계정이 존재하는 동안, 그리고 계정 삭제 후에는 적용되는 현지 법률이 요구하는 바에 따라.|피드백 및 문의: 당사의 고객 지원 메일함에 보관.|귀하의 기기에 저장되는 정보: 귀하가 애플리케이션에서 이를 삭제하거나, 브라우저 데이터를 지우거나, 애플리케이션의 데이터 폴더를 제거하거나, 모바일 애플리케이션을 삭제할 때까지. 내보낸 파일은 귀하가 저장한 위치에 남습니다.',
  'privacy.deletion.title': '계정 삭제',
  'privacy.deletion.content': '귀하는 언제든지 Kizuna AI 대시보드의 계정 페이지에서, 또는 귀하의 계정 이메일 주소에서 privacy@kizuna.ai로 이메일을 보내 계정을 삭제할 수 있습니다. 귀하의 계정이 삭제되면:',
  'privacy.deletion.items': '귀하의 이메일 주소, 표시 이름, 로그인 기록 및 연결된 로그인 방법이 삭제됩니다.|Soniox가 보유한 음성을 포함하여 복제 음성이 삭제됩니다.|악용 방지용 IP 기록은 "데이터 보존"에 기술된 일정에 따라 삭제됩니다.|체험 크레딧 기록은 "데이터 보존"에 기술된 바에 따라 보존됩니다.|과금 및 사용량 기록(Stripe로부터 받은 결제 정보 포함)은 적용되는 현지 법률이 요구하는 바에 따라 보존됩니다.|사용 통계 데이터는 요청 시 삭제됩니다.',
  'privacy.rights.title': '귀하의 권리',
  'privacy.rights.content': '적용되는 법률에 따라, 귀하는 privacy@kizuna.ai로 당사에 연락하여 다음을 할 수 있습니다:',
  'privacy.rights.items': '귀하의 개인정보 열람, 정정 또는 삭제|귀하의 개인정보 사본 수령|귀하의 사용 통계 데이터 삭제 요청|특정 처리에 대한 이의 제기 또는 처리 제한 요청|귀하의 정보가 어떻게 사용되는지에 대한 문의',
  'privacy.gdpr.title': '처리의 법적 근거(유럽경제지역 및 영국)',
  'privacy.gdpr.content': '귀하가 유럽경제지역 또는 영국에 있는 경우, 당사는 귀하와의 계약 이행(귀하의 계정 및 과금 제공)을 위해, 당사의 정당한 이익(본 서비스의 보안 유지, 악용 방지 및 본 서비스 개선)에 근거하여, 그리고 법적 의무 준수(과금 기록 보존 등)를 위해 개인정보를 처리합니다. 귀하는 또한 귀하의 현지 데이터 보호 기관에 불만을 제기할 수 있습니다.',
  'privacy.children.title': '아동 개인정보 보호',
  'privacy.children.content': '본 서비스는 13세 미만의 아동을 대상으로 하지 않으며, 당사는 13세 미만의 아동으로부터 알면서 개인정보를 수집하지 않습니다.',
  'privacy.changes.title': '본 개인정보 보호정책의 변경',
  'privacy.changes.content': '당사는 수시로 본 개인정보 보호정책을 업데이트할 수 있습니다. 당사는 업데이트된 정책을 이 페이지에 게시하고 위의 "최종 업데이트" 날짜를 수정합니다.',
  'privacy.contact.title': '연락처',
  'privacy.contact.content': '본 개인정보 보호정책에 관한 질문이 있으시면:',
  'privacy.contact.email': '이메일: contact@kizuna.ai',
  'privacy.contact.privacy': '개인정보 보호 요청: privacy@kizuna.ai',
  'privacy.contact.github': 'GitHub: github.com/kizuna-ai-lab/sokuji',

  // Terms of Service
  'tos.title': '이용약관',
  'tos.lastUpdated': '최종 업데이트: 2026년 10월 21일',

  'tos.intro.title': '소개 및 동의',
  'tos.intro.content': 'Kizuna AI Lab("당사")이 제공하는 실시간 AI 기반 번역 애플리케이션 "Sokuji"("서비스")에 오신 것을 환영합니다. 본 이용약관("약관")은 브라우저 확장 프로그램, 데스크톱 애플리케이션 및 관련 서비스에 대한 접근 및 사용에 적용됩니다.',
  'tos.intro.agreement': 'Sokuji를 다운로드, 설치, 접근 또는 사용함으로써 본 약관에 구속되는 것에 동의합니다. 본 약관에 동의하지 않는 경우 서비스를 이용하지 마십시오.',

  'tos.definitions.title': '정의',
  'tos.definitions.items': '"서비스"는 브라우저 확장 프로그램, 데스크톱 애플리케이션 및 모든 관련 기능을 포함하는 Sokuji 애플리케이션을 의미합니다.|"사용자", "귀하"는 서비스에 접근하거나 사용하는 개인 또는 법인을 의미합니다.|"잔액"은 Kizuna AI Lab에서 구매하여 Kizuna AI 제공 번역 서비스에 접근하는 데 사용되는 미국 달러(USD) 표시 선불 잔액을 의미합니다.|"제3자 API 키"는 사용자가 제3자 AI 서비스 제공업체(OpenAI, Google, Palabra AI 등)에서 직접 획득한 API 자격 증명을 의미합니다.|"Kizuna AI 서비스"는 귀하의 잔액에서 차감되는 Kizuna AI Lab 인프라를 통해 제공되는 AI 번역 서비스를 의미합니다.',

  'tos.service.title': '서비스 설명',
  'tos.service.overview': 'Sokuji는 두 가지 사용 모드를 통해 실시간 AI 기반 번역 서비스를 제공합니다:',
  'tos.service.freeUsage.title': '무료 사용 모드 (제3자 API 키)',
  'tos.service.freeUsage.items': '지원되는 AI 제공업체(OpenAI, Google Gemini, Soniox, Qwen LiveTranslate, Palabra AI 등)의 자체 API 키 연결 가능|Kizuna AI Lab의 요금 없음; 선택한 AI 제공업체에서 직접 청구|API 키 보안 및 사용 제한 관리는 사용자 책임',
  'tos.service.tokenUsage.title': '선불 잔액 사용 모드 (Kizuna AI 서비스)',
  'tos.service.tokenUsage.items': '사용자는 Kizuna AI Lab에서 미국 달러(USD)로 표시된 선불 잔액을 구매합니다|Kizuna AI가 제공하는 번역 서비스를 이용할 때 잔액에서 요금이 차감됩니다|번역 요금은 AI 제공업체가 측정한 실제 사용량에 따라 부과되며, 금액은 선택한 제공업체에 따라 다릅니다|지갑 페이지에 시간당 예상 요금이 표시됩니다. 실제 사용량을 기준으로 하므로 금액은 대개 예상보다 낮습니다',

  'tos.account.title': '계정 등록',
  'tos.account.age': '서비스를 이용하려면 13세 이상이어야 합니다. 18세 미만인 경우 부모 또는 보호자의 동의를 받았음을 표명합니다. 서비스를 이용함으로써 이 연령 요건을 충족함을 표명하고 보증합니다.',
  'tos.account.content': '잔액 기반 서비스를 포함한 특정 기능에 접근하려면 계정을 생성해야 합니다. 귀하는 다음에 동의합니다:',
  'tos.account.items': '등록 시 정확하고 최신의 완전한 정보 제공|계정 자격 증명의 보안 유지|정보를 정확하고 최신으로 유지하기 위한 즉시 업데이트|계정에서 발생하는 모든 활동에 대한 책임 수락',
  'tos.account.security': '귀하는 계정 비밀번호의 기밀성을 유지하고 계정 접근을 제한할 책임이 있습니다. 계정의 무단 사용이 있는 경우 즉시 당사에 통지해야 합니다.',
  'tos.account.inactivity': '24개월 연속 비활성 상태(로그인 또는 서비스 사용 없음)인 계정은 폐쇄될 수 있습니다. 비활성 계정 폐쇄 최소 30일 전에 통지를 보내드립니다. 비활성 계정의 남은 잔액은 계정 폐쇄 시 몰수됩니다.',

  'tos.notifications.title': '통지 및 커뮤니케이션',
  'tos.notifications.methods': '당사는 다음 방법으로 통지를 보낼 수 있습니다: (a) Sokuji 내 앱 내 알림; (b) 계정에 연결된 이메일 주소로 이메일; (c) 웹사이트에 공지 게시. 귀하는 이메일 주소를 최신 상태로 유지할 책임이 있습니다.',
  'tos.notifications.consent': '계정을 생성함으로써 이러한 방법을 통해 중요한 서비스 관련 커뮤니케이션을 받는 것에 동의합니다.',

  'tos.tokens.title': '잔액 및 결제',
  'tos.tokens.purchase.title': '잔액 구매',
  'tos.tokens.purchase.items': '지원되는 결제 방법을 사용하여 애플리케이션에서 잔액 구매 가능|모든 가격은 구매 시점의 해당 통화로 표시됨|잔액은 계정 간 양도 불가|충전으로 추가된 잔액은 해당 충전일로부터 1년간 유효',
  'tos.tokens.tax': '표시 가격에는 해당 소비세(일본) 또는 부가가치세가 포함되어 있습니다. 일본 외 지역에서 구매 시 관할 지역에 따라 현지 세금이 적용될 수 있습니다.',
  'tos.tokens.expiration': '잔액 만료 최소 30일 전에 알림 통지를 보내드립니다. 만료된 잔액은 자동으로 소멸되며 복구, 환불 또는 연장이 불가능합니다. 잔액 만료 전에 사용하는 것은 귀하의 책임입니다.',
  'tos.tokens.promotional': '당사는 이메일 주소 인증 시 제공되는 체험 크레딧과 같은 프로모션 잔액을 무료로 귀하의 계정에 추가할 수 있습니다. 프로모션 잔액의 유효 기간은 지급 시 안내된 기간(이메일 인증 체험 크레딧은 칠(7)일)이며, 구매한 잔액보다 먼저 사용됩니다. 위의 30일 사전 알림은 프로모션 잔액에 적용되지 않으며, 지급 안내가 유일한 알림입니다. 프로모션 잔액은 환불 또는 양도할 수 없으며 만료 시 소멸됩니다.',
  'tos.tokens.consumption.title': '잔액 차감',
  'tos.tokens.consumption.content': '번역 요금은 사용된 AI 서비스가 측정한 실제 사용량에 따라 부과되므로, 금액은 제공업체와 모델에 따라 다릅니다. 지갑 페이지에 시간당 예상 요금이 표시되며, 실제 사용량을 기준으로 하므로 금액은 대개 예상보다 낮습니다. 잔액은 세션 중에 계속 차감되는 것이 아니라, 세션 종료 직후 제공업체가 사용량을 보고한 시점에 갱신됩니다.',
  'tos.tokens.refund.title': '환불 정책',
  'tos.tokens.refund.items': '미사용 잔액: 구매 후 14일 이내에 미사용 잔액 환불 요청 가능. 처리 수수료가 적용될 수 있음.|사용된 잔액: 이미 차감된 잔액은 환불 불가.|서비스 문제: Kizuna AI Lab이 단독으로 판단하는 기술적 문제로 인해 잔액이 차감된 경우, 다음 조건에 따라 영향받은 금액을 계정에 크레딧할 수 있습니다: (a) 문제 발생 후 30일 이내에 보고해야 함; (b) 계정당 연간 총 크레딧은 해당 연도에 구매한 잔액의 20%를 초과할 수 없음; (c) Kizuna AI Lab은 기술적 문제 여부 및 크레딧 보증 여부를 결정할 단독 권한을 보유함.|환불 절차: support@kizuna.ai로 구매 세부 정보 및 환불 사유를 연락하세요.',

  'tos.thirdParty.title': '무료 서비스 (제3자 API 키)',
  'tos.thirdParty.content': '제3자 제공업체의 자체 API 키를 사용할 경우:',
  'tos.thirdParty.items': 'API 키 획득 및 관리에 대한 전적인 책임은 귀하에게 있음|각 제3자 제공업체의 서비스 약관을 준수해야 함|제3자 제공업체에서 발생하는 모든 요금에 대한 책임은 귀하에게 있음|API 키는 귀하의 기기에 로컬로 저장되며 당사 서버로 전송되지 않음',
  'tos.thirdParty.noWarranty': '당사는 제3자 AI 서비스의 가용성, 품질 또는 성능에 대해 어떠한 보증도 하지 않습니다. 제3자 서비스 관련 문제는 해당 제공업체에 직접 문의하세요.',

  'tos.use.title': '이용 규정',
  'tos.use.permitted.title': '허용된 사용',
  'tos.use.permitted.items': '개인 실시간 번역|비즈니스 커뮤니케이션 번역|교육 목적|접근성 지원',
  'tos.use.prohibited.title': '금지 활동',
  'tos.use.prohibited.items': '불법적이거나 무단 목적으로 서비스 사용|서비스 리버스 엔지니어링, 디컴파일 또는 분해 시도|서비스 또는 서버 간섭 또는 방해|유해, 공격적 또는 불법 콘텐츠 전송에 서비스 사용|무단으로 서비스 접근 재판매, 재라이선스 또는 상업화|보안 조치 또는 접근 제한 우회|정상 사용을 초과한 자동화 시스템 또는 봇으로 서비스 접근|관련 법률 또는 규정 위반',

  'tos.ip.title': '지적재산권',
  'tos.ip.ownership': '모든 소프트웨어, 콘텐츠, 기능을 포함한 서비스는 Kizuna AI Lab이 소유하며 국제 저작권법, 상표법 및 기타 지적재산권법에 의해 보호됩니다.',
  'tos.ip.license': '본 약관에 따라, 당사는 개인 또는 내부 업무 목적으로 서비스를 사용할 수 있는 제한적, 비독점적, 양도 불가, 취소 가능한 라이선스를 부여합니다.',
  'tos.ip.userContent': '서비스를 통해 제공하는 콘텐츠의 소유권은 귀하에게 있습니다. 오디오 및 번역 콘텐츠는 실시간으로 처리되며 당사가 저장하지 않습니다.',

  'tos.disclaimer.title': '면책 조항',
  'tos.disclaimer.asIs': '"있는 그대로" 서비스 제공',
  'tos.disclaimer.items': '상품성 또는 특정 목적 적합성에 대한 묵시적 보증|번역의 정확성, 신뢰성 또는 완전성|중단 없는 또는 오류 없는 작동|바이러스 또는 기타 유해 구성요소 부재',
  'tos.disclaimer.accuracy': 'AI 번역에는 오류가 포함될 수 있습니다. 중요한 커뮤니케이션, 법적 문서, 의료 정보 또는 안전에 중요한 애플리케이션에서 번역에만 의존해서는 안 됩니다.',
  'tos.disclaimer.availability': '당사는 서비스가 항상 사용 가능하다고 보장하지 않습니다. 서비스는 인터넷 및 전자 통신 사용에 내재된 제한, 지연 및 기타 문제의 영향을 받을 수 있습니다.',

  'tos.liability.title': '책임 제한',
  'tos.liability.items': 'Kizuna AI Lab은 간접적, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임지지 않습니다|당사의 총 책임은 청구 이전 12개월 동안 잔액에 대해 지불한 금액을 초과하지 않습니다|당사는 귀하의 계정에 대한 무단 접근으로 인한 손실에 대해 책임지지 않습니다|당사는 제3자 AI 서비스에서 발생하는 문제에 대해 책임지지 않습니다',

  'tos.indemnification.title': '면책',
  'tos.indemnification.content': '귀하는 서비스 사용, 본 약관 위반, 제3자 권리 침해 또는 제3자 API 키 사용으로 인해 발생하는 청구, 손해, 손실, 책임 및 비용(변호사 비용 포함)으로부터 Kizuna AI Lab, 임원, 이사, 직원 및 대리인을 면책하고 무해하게 유지하는 데 동의합니다.',

  'tos.termination.title': '종료',
  'tos.termination.byUser.title': '사용자에 의한 종료',
  'tos.termination.byUser.items': '언제든지 서비스 사용을 중단하고 계정을 삭제할 수 있습니다|미사용 잔액은 몰수될 수 있습니다(환불 정책에 따름)|서비스 접근 권한이 즉시 중단됩니다',
  'tos.termination.byUs.title': '당사에 의한 종료',
  'tos.termination.byUs.items': '본 약관을 위반한 경우 접근을 일시 중지하거나 종료할 수 있습니다|귀하의 사용이 보안 위험을 초래하는 경우 종료할 수 있습니다|법률에 의해 요구되는 경우 종료할 수 있습니다|서비스를 중단하는 경우 종료할 수 있습니다',
  'tos.termination.discontinuation': '서비스를 완전히 중단하는 경우 최소 30일 전에 통지합니다. 이 경우 미사용 잔액을 보유한 사용자는 중단 전 12개월 이내에 구매한 잔액에 대해 처리 수수료를 제외한 비례 환불을 요청할 수 있습니다. 환불 요청은 중단 통지 후 60일 이내에 제출해야 합니다.',

  'tos.changes.title': '약관 변경',
  'tos.changes.content': '당사는 언제든지 본 약관을 수정할 수 있습니다. 중요한 변경 사항은 이 페이지에 업데이트된 약관을 게시하고, "최종 업데이트" 날짜를 업데이트하며, 중요한 변경 사항에 대해 앱 내 알림 또는 이메일을 보내 알려드립니다. 변경 후 서비스를 계속 사용하면 수정된 약관에 동의하는 것으로 간주됩니다.',

  'tos.governing.title': '준거법 및 분쟁 해결',
  'tos.governing.informalResolution': '정식 법적 절차를 시작하기 전에 양 당사자는 먼저 성실한 협상을 통해 분쟁 해결을 시도하는 데 동의합니다. 불만 당사자는 분쟁을 설명하는 서면 통지를 상대방에게 보내야 합니다. 그 후 양 당사자는 60일 동안 비공식 해결을 시도합니다. 이 기간 내에 비공식적으로 해결되지 않으면 어느 당사자든 아래 설명된 정식 법적 조치를 진행할 수 있습니다.',
  'tos.governing.law': '본 약관은 법률 충돌 조항과 관계없이 일본 법률에 의해 규율되고 해석됩니다.',
  'tos.governing.jurisdiction': '본 약관 또는 서비스와 관련하여 발생하는 분쟁은 일본 도쿄 법원의 전속 관할에 따릅니다.',
  'tos.governing.language': '본 약관의 영문판과 일본어판 간에 불일치가 있는 경우, 일본 내 사용자에게는 일본어판이 우선합니다.',

  'tos.general.title': '일반 조항',
  'tos.general.entireAgreement': '본 약관은 개인정보 보호정책과 함께 서비스에 관한 귀하와 Kizuna AI Lab 간의 완전한 합의를 구성합니다.',
  'tos.general.severability': '본 약관의 어떤 조항이 집행 불가능하다고 판단되면 나머지 조항은 계속 완전한 효력을 유지합니다.',
  'tos.general.waiver': '본 약관의 권리 또는 조항을 행사하지 않더라도 해당 권리의 포기로 간주되지 않습니다.',
  'tos.general.forceMajeure': 'Kizuna AI Lab은 자연재해, 전쟁, 테러, 폭동, 팬데믹, 정부 조치, 정전, 인터넷 또는 통신 장애, 제3자 서비스 제공업체 장애를 포함하되 이에 국한되지 않는 합리적인 통제를 벗어난 상황으로 인한 본 약관상 의무 불이행 또는 지연에 대해 책임지지 않습니다.',

  'tos.contact.title': '연락처',
  'tos.contact.content': '본 약관에 대한 질문이 있으시면 연락해 주세요:',
  'tos.contact.legal': '법무: legal@kizuna.ai',
  'tos.contact.support': '지원: support@kizuna.ai',
  'tos.contact.github': 'GitHub: github.com/kizuna-ai-lab/sokuji',

  // Dashboard Navigation
  'dashboard.nav.dashboard': '대시보드',
  'dashboard.nav.profile': '프로필',
  'dashboard.nav.security': '보안',
  'dashboard.nav.feedback': '피드백',
  'dashboard.nav.signOut': '로그아웃',
  'dashboard.user.fallback': '사용자',
  'dashboard.sidebar.collapse': '사이드바 접기',
  'dashboard.sidebar.expand': '사이드바 펼치기',

  // Dashboard Home
  'dashboard.home.welcomeBack': '다시 오신 것을 환영합니다, {name}님',
  'dashboard.home.subtitle': '계정 설정 및 환경 설정 관리',
  'dashboard.home.accountOverview': '계정 개요',
  'dashboard.home.accountStatus': '계정 상태',
  'dashboard.home.accountDetails': '계정 상세',
  'dashboard.home.quickActions': '빠른 작업',
  'dashboard.home.name': '이름',
  'dashboard.home.email': '이메일',
  'dashboard.home.emailVerified': '이메일 인증',
  'dashboard.home.accountType': '계정 유형',
  'dashboard.home.userId': '사용자 ID',
  'dashboard.home.created': '생성일',
  'dashboard.home.lastUpdated': '최종 수정',
  'dashboard.home.notSet': '설정되지 않음',
  'dashboard.home.verified': '인증됨',
  'dashboard.home.notVerified': '미인증',
  'dashboard.home.anonymous': '익명',
  'dashboard.home.registered': '등록됨',
  'dashboard.home.editProfile': '프로필 편집',
  'dashboard.home.securitySettings': '보안 설정',
  'dashboard.home.na': 'N/A',

  // Dashboard Profile
  'dashboard.profile.title': '프로필 설정',
  'dashboard.profile.subtitle': '개인 정보 관리',
  'dashboard.profile.personalInfo': '개인 정보',
  'dashboard.profile.personalInfoDesc': '이름 및 기본 정보 업데이트',
  'dashboard.profile.nameLabel': '이름',
  'dashboard.profile.namePlaceholder': '이름을 입력하세요',
  'dashboard.profile.saveChanges': '변경 사항 저장',
  'dashboard.profile.profileUpdated': '프로필이 업데이트되었습니다',
  'dashboard.profile.emailAddress': '이메일 주소',
  'dashboard.profile.emailAddressDesc': '이메일 주소 및 인증 상태 관리',
  'dashboard.profile.currentEmail': '현재 이메일',
  'dashboard.profile.verified': '인증됨',
  'dashboard.profile.notVerified': '미인증',
  'dashboard.profile.resendVerification': '인증 메일 재전송',
  'dashboard.profile.verificationSent': '인증 메일이 전송되었습니다! 받은 편지함을 확인하세요.',
  'dashboard.profile.changeEmailTitle': '이메일 주소 변경',
  'dashboard.profile.newEmailLabel': '새 이메일 주소',
  'dashboard.profile.newEmailPlaceholder': 'new@email.com',
  'dashboard.profile.newEmailHint': '새 주소로 인증 메일이 전송됩니다',
  'dashboard.profile.changeEmail': '이메일 변경',
  'dashboard.profile.emailChangeSent': '새 이메일 주소로 인증 메일이 전송되었습니다. 확인해 주세요.',

  // Dashboard Security
  'dashboard.security.title': '보안 설정',
  'dashboard.security.subtitle': '비밀번호 및 계정 보안 관리',
  'dashboard.security.changePassword': '비밀번호 변경',
  'dashboard.security.changePasswordDesc': '계정 보안을 위해 비밀번호 업데이트',
  'dashboard.security.currentPassword': '현재 비밀번호',
  'dashboard.security.currentPasswordPlaceholder': '현재 비밀번호 입력',
  'dashboard.security.newPassword': '새 비밀번호',
  'dashboard.security.newPasswordPlaceholder': '최소 8자 이상',
  'dashboard.security.confirmPassword': '새 비밀번호 확인',
  'dashboard.security.confirmPasswordPlaceholder': '새 비밀번호 확인',
  'dashboard.security.changePasswordBtn': '비밀번호 변경',
  'dashboard.security.activeSessions': '활성 세션',
  'dashboard.security.activeSessionsDesc': '활성 로그인 세션 관리 ({count}개 활성)',
  'dashboard.security.current': '현재',
  'dashboard.security.lastActive': '마지막 활동: {time}',
  'dashboard.security.loadingSessions': '세션 로딩 중...',
  'dashboard.security.signOutOther': '다른 모든 세션 로그아웃',
  'dashboard.security.deleteAccount': '계정 삭제',
  'dashboard.security.deleteAccountDesc': '계정 및 모든 관련 데이터를 영구적으로 삭제',
  'dashboard.security.deleteWarning': '이 작업은 되돌릴 수 없습니다. 모든 데이터가 영구적으로 삭제됩니다.',
  'dashboard.security.deleteBtn': '내 계정 삭제',
  'dashboard.security.deleteConfirmText': '삭제를 확인하려면 아래에 DELETE를 입력하세요:',
  'dashboard.security.deleteConfirmPlaceholder': 'DELETE를 입력하여 확인',
  'dashboard.security.cancel': '취소',
  'dashboard.security.anonymousNote': '익명 계정은 비밀번호를 변경할 수 없습니다. 먼저 정식 계정으로 전환하세요.',
  'dashboard.security.passwordMinLength': '새 비밀번호는 최소 8자 이상이어야 합니다',
  'dashboard.security.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'dashboard.security.passwordIncorrect': '현재 비밀번호가 올바르지 않습니다',
  'dashboard.security.passwordSuccess': '비밀번호가 변경되었습니다. 다른 세션은 로그아웃되었습니다.',
  'dashboard.security.typeDelete': 'DELETE를 입력하여 확인하세요',

  // Dashboard Feedback
  'dashboard.feedback.title': '피드백 보내기',
  'dashboard.feedback.subtitle': '버그 신고, 기능 제안 또는 의견을 공유해 주세요. 모든 메시지를 읽고 있습니다!',
  'dashboard.feedback.yourFeedback': '피드백',
  'dashboard.feedback.sendingAs': '발신자: {email}',
  'dashboard.feedback.remainingCount': '오늘 남은 피드백: {remaining}/{limit}개',
  'dashboard.feedback.limitReached': '일일 한도에 도달했습니다. 내일 다시 피드백을 보낼 수 있습니다.',
  'dashboard.feedback.feedbackType': '피드백 유형',
  'dashboard.feedback.bugReport': '버그 신고',
  'dashboard.feedback.bugReportDesc': '문제 또는 오류 신고',
  'dashboard.feedback.suggestion': '기능 제안',
  'dashboard.feedback.suggestionDesc': '새 기능 또는 개선 제안',
  'dashboard.feedback.other': '기타',
  'dashboard.feedback.otherDesc': '일반 피드백 또는 질문',
  'dashboard.feedback.message': '메시지',
  'dashboard.feedback.messagePlaceholder': '피드백을 자세히 설명해 주세요...',
  'dashboard.feedback.messageHint': '{count}/5000자 (최소 10자)',
  'dashboard.feedback.sendFeedback': '피드백 보내기',
  'dashboard.feedback.verificationRequired': '이메일 인증 필요',
  'dashboard.feedback.verificationRequiredDesc': '피드백을 제출하기 전에 이메일 주소를 인증해 주세요. 답변을 위해 인증된 이메일이 필요합니다.',
  'dashboard.feedback.goToProfile': '프로필 설정으로 이동',
  'dashboard.feedback.thankYou': '감사합니다! 피드백이 성공적으로 전송되었습니다.',

  // Dashboard Wallet
  'dashboard.wallet.title': '지갑',
  'dashboard.wallet.subtitle': '잔액 및 충전 관리',
  'dashboard.wallet.balance': '잔액',
  'dashboard.wallet.hoursLeft': '예상 사용 시간 ({scenario})',
  'dashboard.wallet.hoursLeftAverage': '예상 사용 시간 (최근 30일 평균 {rate}/시간)',
  'dashboard.wallet.hoursValue': '약 {hours}시간',
  'dashboard.wallet.recentRecords': '최근 기록',
  'dashboard.wallet.allRecords': '전체 기록',
  'dashboard.wallet.fullPricing': '전체 요금표',
  'dashboard.wallet.plan': '현재 플랜',
  'dashboard.wallet.last30Days': '최근 30일',
  'dashboard.wallet.expiringSoon': '${amount}이(가) {date}에 만료됩니다',
  'dashboard.wallet.expiringSoonPartial': '${amount}이(가) {date}에 만료, 한 달 내 총 ${total}',
  'dashboard.wallet.accountFrozen': '계정이 정지되었습니다. 고객 지원에 문의하세요.',
  'dashboard.wallet.topUp': '충전',
  'dashboard.wallet.customAmount': '직접 입력',
  'dashboard.wallet.amountRange': '최소: {min} - 최대: {max}',
  'dashboard.wallet.youWillReceive': '받게 될 금액',
  'dashboard.wallet.paymentMethod': '결제 수단',
  'dashboard.wallet.methodCard': '카드',
  'dashboard.wallet.methodAlipay': '알리페이',
  'dashboard.wallet.continueWithAmount': '결제로 진행 · {amount}',
  'dashboard.wallet.poweredByStripe': '결제는 Stripe를 통해 안전하게 처리됩니다.',
  'dashboard.wallet.alipayCharge': '엔화로 청구: {amount}',
  'dashboard.wallet.alipayRate': '환율 1 USD = {rate} JPY (유럽중앙은행, {date})',
  'dashboard.wallet.alipayRateChanged': '환율이 방금 업데이트되었습니다. 새 금액을 확인한 후 다시 시도해 주세요.',
  'dashboard.wallet.otherPaymentMethods': '다른 결제 수단',
  'dashboard.wallet.processing': '처리 중...',
  'dashboard.wallet.pricing.provider': 'Soniox의 청구 방식, 실시간 스트리밍 전용',

  // THE CALCULATOR. Its scenario presets, and their titles and descriptions,
  // follow kizuna-ai-lab/sokuji's own first-run wizard
  // (`setup.scenarios.*` there) so the dashboard and the app name the same
  // thing the same way, as are /scenarios' `scenario.<id>.title`/`.body`. The
  // two repos cannot share catalogs: `app-scenarios.fixture.ts` pins the
  // wizard's strings and `scenario-copy.test.ts` holds both pages to them, so
  // when the app rewords a scenario, update the fixture and these together.
  'dashboard.wallet.pricing.calcTitle': '비용 계산기',
  'dashboard.wallet.pricing.calcScenario': '무엇에 사용하시나요?',
  'dashboard.wallet.pricing.calcEstimate': '예상 비용',
  'dashboard.wallet.pricing.calcFactors': '이 예상 비용의 구성',
  'dashboard.wallet.pricing.scenario.understand-others.title': '상대방의 말 이해하기',
  'dashboard.wallet.pricing.scenario.understand-others.desc': '온라인 회의, 수업, 강연, 영상, 스트리밍 — 듣는 내용을 실시간 번역으로 읽습니다.',
  'dashboard.wallet.pricing.scenario.be-heard.title': '회의에서 내 말 전달하기',
  'dashboard.wallet.pricing.scenario.be-heard.desc': '상대방은 가상 마이크를 통해 번역된 내 목소리를 듣습니다.',
  'dashboard.wallet.pricing.scenario.subtitle-myself.title': '내 말에 자막 달기',
  'dashboard.wallet.pricing.scenario.subtitle-myself.desc': '강연, 스트리밍, 발표 — 청중이 번역된 자막을 읽습니다. 음성은 생성되지 않습니다.',
  'dashboard.wallet.pricing.scenario.two-way-voice.title': '양방향 온라인 대화',
  'dashboard.wallet.pricing.scenario.two-way-voice.desc': '상대방은 번역된 내 목소리를 듣고, 나는 상대방의 자막을 읽으며 번역 음성도 들을 수 있습니다.',
  'dashboard.wallet.pricing.scenario.two-way-text.title': '양방향 온라인 대화, 자막만',
  'dashboard.wallet.pricing.scenario.two-way-text.desc': '이중 언어 자막, 회의록 — 양쪽 모두 텍스트로, 합성 음성 없음.',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.title': '마주 보고 대화',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.desc': '한 대의 컴퓨터 앞에서 두 사람이 각자의 언어로 말합니다. 각자 이어버드를 한쪽씩 끼고 자기 언어로 된 번역만 듣습니다.',
  'dashboard.wallet.pricing.scenario.face-to-face-text.title': '마주 보고 대화, 자막만',
  'dashboard.wallet.pricing.scenario.face-to-face-text.desc': '둘이 같은 화면을 보거나, 상대방이 휴대폰으로 LAN 자막 페이지를 엽니다.',
  'dashboard.wallet.pricing.engine': '엔진',
  'dashboard.wallet.pricing.region': '지역',
  'dashboard.wallet.pricing.regionSg': '싱가포르',
  'dashboard.wallet.pricing.regionCn': '베이징',
  'dashboard.wallet.pricing.scenario.custom.title': '사용자 지정',
  'dashboard.wallet.pricing.scenario.custom.desc': '아래 항목을 사용 방식에 맞게 설정하세요. 어느 항목이든 바꾸면 이 항목으로 전환됩니다.',
  'dashboard.wallet.pricing.sideThem': '상대방의 말',
  'dashboard.wallet.pricing.sideMe': '나의 말',
  'dashboard.wallet.pricing.output.off': '번역 안 함',
  'dashboard.wallet.pricing.output.text': '자막 표시',
  'dashboard.wallet.pricing.output.voiceThem': '나에게 읽어 주기',
  'dashboard.wallet.pricing.output.voiceMe': '상대방에게 읽어 주기',
  'dashboard.wallet.pricing.shareThem': '상대방이 말하는 시간',
  'dashboard.wallet.pricing.shareMe': '내가 말하는 시간',
  'dashboard.wallet.pricing.shareValue': '{count}% · 시간당 약 {minutes}분',
  'dashboard.wallet.pricing.screenContext': '화면 컨텍스트',
  'dashboard.wallet.pricing.screenContextHint': 'Qwen 엔진이 직접 고른 창, 탭 또는 화면 하나를 봅니다. 발화 1시간당, 방향별로 과금됩니다.',
  'dashboard.wallet.pricing.balanceLasts': '잔액 {balance}(으)로 약 {hours}시간 사용 가능',
  'dashboard.wallet.pricing.balanceLastsUnderOne': '잔액 {balance}(으)로는 1시간이 채 안 됩니다',
  'dashboard.wallet.pricing.trait.soniox': '60개 언어를 서로 번역하며 자막과 음성을 모두 지원합니다. 기본 제공 음성 외에 녹음으로 나만의 목소리를 만들 수 있고, 컴퓨터 한 대로 마주 보고 대화할 수도 있습니다.',
  'dashboard.wallet.pricing.trait.qwen': '말하는 사람 본인의 목소리로 번역을 읽어 줄 수 있습니다. 문장마다 실시간으로 목소리를 복제하므로 미리 녹음할 필요가 없습니다. 29개 언어를 읽어 주고, 60개 언어를 자막으로 표시합니다.',
  'dashboard.wallet.pricing.sharedActive': '공유 스트림 하나로 계산: 마주 보고 대화할 때는 두 방향이 연결 하나를 함께 씁니다.',
  'dashboard.wallet.pricing.sharedHint': '마주 보고 대화하거나 양쪽이 스트림 하나를 공유하면 연결이 하나 줄어 시간당 약 {amount} 저렴해집니다.',
  'dashboard.wallet.pricing.needOneSide': '가격을 보려면 적어도 한쪽의 말을 번역하세요.',
  'dashboard.wallet.pricing.partConnection': '연결 × {count}',
  'dashboard.wallet.pricing.partText': '텍스트',
  'dashboard.wallet.pricing.partVoice': '음성',
  'dashboard.wallet.pricing.partScreen': '화면 컨텍스트',
  'dashboard.wallet.pricing.partTotal': '합계',
  'dashboard.wallet.pricing.colItem': '항목',
  'dashboard.wallet.pricing.colUnitPrice': '단가',
  'dashboard.wallet.pricing.colHourly': '시간당',
  'dashboard.wallet.pricing.usePerConnectedHour': '연결 1시간당 {count} 토큰',
  'dashboard.wallet.pricing.usePerSpeechHour': '발화 1시간당 {count} 토큰',
  'dashboard.wallet.pricing.usePerSpokenHour': '읽어 주기 1시간당 {count} 토큰',
  'dashboard.wallet.pricing.usePerScreenHour': '화면 컨텍스트 사용 시 발화 1시간당 {count} 토큰',
  'dashboard.wallet.pricing.providerQwen': '{name}의 청구 방식, 실시간 스트리밍 전용',

  'dashboard.wallet.pricing.perHourApprox': '≈ {amount}/시간',
  'dashboard.wallet.pricing.assumptions': '번역하는 방향마다 연결이 하나이며, 누가 말하든 말하지 않든 연결된 시간 내내 요금이 부과됩니다. 텍스트는 번역되는 사람이 말하는 시간에, 음성은 읽어 준 분량에만 부과됩니다. 말하는 시간은 사람마다 따로 설정하므로 한쪽을 켜면 그쪽 요금만 더해집니다.',
  'dashboard.wallet.pricing.settlement': '이 수치는 견적이며 확정 요금이 아닙니다. 실제로 청구되는 금액은 엔진이 해당 세션에 대해 보고하는 토큰 수를 기준으로 결정됩니다.',
  'dashboard.wallet.pricing.rateInputAudio': '입력 오디오 토큰',
  'dashboard.wallet.pricing.rateOutputText': '출력 텍스트 토큰',
  'dashboard.wallet.pricing.rateTtsInputText': '입력 텍스트 토큰',
  'dashboard.wallet.pricing.rateTtsOutputAudio': '출력 오디오 토큰',
  'dashboard.wallet.pricing.rateInputImage': '입력 이미지 토큰(화면 컨텍스트)',
  'dashboard.wallet.pricing.perMillion': '{amount} / 100만 토큰',
  'dashboard.wallet.pricing.cnyPerMillion': 'CN¥{amount} / 100만 토큰',
  'dashboard.wallet.pricing.fxNote': '{date} 유럽중앙은행 환율로 환산: 1 USD = {rate} CNY. 환율은 매일 갱신됩니다.',
  'dashboard.wallet.pricing.sttReference': '오디오 1시간은 약 30,000개의 입력 오디오 토큰 • 발화 1시간은 약 15,000개의 출력 텍스트 토큰 • 출력 1자는 약 0.3토큰',
  'dashboard.wallet.pricing.ttsReference': '1자 ≈ 0.3 입력 텍스트 토큰 • 15,000 입력 텍스트 토큰 ≈ 생성된 음성 1시간 • 생성된 음성 1시간 ≈ 30,000 출력 오디오 토큰',
  'dashboard.wallet.pricing.referenceNote': '제공업체에서 인용한 내용입니다. 번역은 스크립트와 번역문을 함께 생성하므로, 발화 1시간당 위에 인용된 출력 텍스트 토큰의 약 두 배가 생성됩니다 — 표에서 사용하는 수치는 이 값입니다.',
  'dashboard.wallet.pricing.readOn': '제공자 가격은 {date} 기준입니다.',
  'dashboard.wallet.pricing.error': '가격 정보를 불러오지 못했습니다',
  'dashboard.wallet.pricing.retry': '다시 시도',
  'dashboard.wallet.pricing.boundariesHeading': '요금이 부과되는 항목',
  'dashboard.wallet.pricing.boundaryConnection': '연결된 스트림은 누군가 말하고 있는지 여부와 관계없이 요금이 부과됩니다. 각 스트림은 연결되어 있는 것만으로도 시간당 약 {count}개의 입력 오디오 토큰을 사용하며, 발화가 있으면 그 위에 출력 텍스트가 추가됩니다.',
  'dashboard.wallet.pricing.boundaryReservation': '세션을 시작하면 보수적인 요율로 이를 충당할 만큼의 잔액이 예약되며, 이 예약이 세션을 실행할 수 있는 시간을 결정합니다. 잔액은 실제로 사용한 만큼만 변동되며, 예약 중 사용되지 않은 부분은 절대 차감되지 않습니다.',
  'dashboard.wallet.pricing.boundaryCurrency': '모든 금액은 미국 달러 기준입니다.',
  'dashboard.wallet.pricing.faqHeading': '자주 묻는 질문',
  'dashboard.wallet.pricing.faqTranslationQ': '번역은 별도로 청구되나요?',
  'dashboard.wallet.pricing.faqTranslationA': '아니요. 전사와 번역은 동일한 스트림에서 이루어지며, 번역 비용은 위 요율에 이미 포함되어 있습니다.',
  'dashboard.wallet.pricing.faqFeaturesQ': '화자 분리, 언어 감지, 서식 지정은 추가 비용이 발생하나요?',
  'dashboard.wallet.pricing.faqFeaturesA': '아니요. 화자 분리, 언어 식별, 스마트 서식 지정은 추가 비용 없이 포함되어 있습니다.',
  'dashboard.billing.title': '결제',
  'dashboard.billing.subtitle': '잔액, 크레딧 및 결제',
  'dashboard.usage.title': '사용량',
  'dashboard.usage.subtitle': '세션이 사용한 내역',
  'dashboard.usage.sessionTime': '세션 시간',
  'dashboard.usage.sessions': '세션',
  'dashboard.usage.chartStart': '{{days}}일 전',
  'dashboard.usage.chartEnd': '오늘',
  'dashboard.usage.chartLabel': '기간 내 일별 사용액',
  'dashboard.usage.noSpend': '사용 없음',
  'dashboard.wallet.ledger.billingTitle': '결제 내역',
  'dashboard.wallet.ledger.viewReceipt': '영수증 보기',
  'dashboard.wallet.lots.title': '크레딧',
  'dashboard.wallet.lots.totalRemaining': '사용 가능',
  'dashboard.wallet.lots.colCreated': '추가일',
  'dashboard.wallet.lots.colAmount': '금액',
  'dashboard.wallet.lots.colUsed': '사용함',
  'dashboard.wallet.lots.colRemaining': '남음',
  'dashboard.wallet.lots.colExpires': '만료일',
  'dashboard.wallet.lots.colStatus': '상태',
  'dashboard.wallet.lots.status.active': '유효',
  'dashboard.wallet.lots.status.expiring': '곧 만료',
  'dashboard.wallet.lots.status.spent': '모두 사용',
  'dashboard.wallet.lots.status.expired': '만료됨',
  'dashboard.wallet.lots.empty': '크레딧이 아직 없습니다.',
  'dashboard.wallet.lots.error': '크레딧을 불러오지 못했습니다.',
  'dashboard.wallet.lots.retry': '다시 시도',
  'dashboard.wallet.paymentHistory': '결제 내역',
  'dashboard.wallet.noHistory': '결제 내역이 없습니다',
  'dashboard.wallet.loading': '지갑 로딩 중...',
  'dashboard.wallet.paymentSuccess': '결제가 완료되었습니다! 잔액이 업데이트되었습니다.',
  'dashboard.wallet.paymentUnavailable': '온라인 결제를 현재 사용할 수 없습니다. 나중에 다시 시도해 주세요.',
  'dashboard.wallet.errorFetchingBalance': '지갑 잔액을 가져오지 못했습니다',
  'dashboard.wallet.minAmountError': '최소 금액은 {min}입니다',
  'dashboard.wallet.maxAmountError': '최대 금액은 {max}입니다',
  'dashboard.wallet.paymentError': '결제에 실패했습니다. 다시 시도해 주세요.',

  // Dashboard Wallet — billing ledger
  'dashboard.wallet.ledger.title': '거래 내역',
  'dashboard.wallet.ledger.kind.sttSpeaker': '내 음성 인식',
  'dashboard.wallet.ledger.kind.sttParticipant': '상대방 음성 인식',
  'dashboard.wallet.ledger.kind.translateSpeaker': '내 음성 번역',
  'dashboard.wallet.ledger.kind.translateParticipant': '상대방 음성 번역',
  'dashboard.wallet.ledger.kind.sttMixed': '통합 음성 인식',
  'dashboard.wallet.ledger.kind.stt': '음성 인식',
  'dashboard.wallet.ledger.kind.tts': '음성 합성',
  'dashboard.wallet.ledger.kind.ttsPreview': '음성 미리듣기',
  'dashboard.wallet.ledger.kind.topup': '충전',
  'dashboard.wallet.ledger.kind.grant': '지급 크레딧',
  'dashboard.wallet.ledger.kind.adjustment': '계정 조정',
  'dashboard.wallet.ledger.kind.refund': '환불',
  'dashboard.wallet.ledger.kind.expired': '잔액 만료',
  'dashboard.wallet.ledger.kind.usage': '사용',
  'dashboard.wallet.ledger.kind.voicePreview': '음성 미리듣기',
  'dashboard.wallet.ledger.group.session': '번역 세션',
  'dashboard.wallet.ledger.mode.me': '나',
  'dashboard.wallet.ledger.mode.other': '상대방',
  'dashboard.wallet.ledger.mode.both': '둘 다',
  'dashboard.wallet.ledger.textOnly': '텍스트만',
  'dashboard.wallet.ledger.poweredBy': '{name} 제공',
  'dashboard.wallet.engine.qwenSingapore': 'Qwen (싱가포르)',
  'dashboard.wallet.engine.qwenBeijing': 'Qwen (베이징)',
  'dashboard.wallet.ledger.segments': '구간',
  'dashboard.wallet.ledger.prevPage': '이전',
  'dashboard.wallet.ledger.nextPage': '다음',
  'dashboard.wallet.ledger.prevPageAria': '이전 페이지',
  'dashboard.wallet.ledger.nextPageAria': '다음 페이지',
  'dashboard.wallet.ledger.page': '{page}페이지',
  'dashboard.wallet.ledger.empty': '아직 거래 내역이 없습니다',
  'dashboard.wallet.ledger.error': '거래 내역을 불러오지 못했습니다',
  'dashboard.wallet.ledger.retry': '다시 시도',
  'dashboard.wallet.ledger.expandRow': '세부 내역 보기',
  'dashboard.wallet.ledger.collapseRow': '세부 내역 숨기기',

  // Dashboard Navigation - Wallet
  'dashboard.nav.wallet': '지갑',
  'dashboard.nav.billing': '결제',
  'dashboard.nav.usage': '사용량',

  // Commerce Disclosure (特定商取引法に基づく表記)
  'commerce.title': '상거래 정보 공개',
  'commerce.lastUpdated': '최종 업데이트: 2026년 10월 6일',

  // Operator Information
  'commerce.operator.title': '사업자 정보',
  'commerce.operator.name.label': '사업자명',
  'commerce.operator.name.value': 'Kizuna AI Lab',
  'commerce.operator.representative.label': '운영 책임자',
  'commerce.operator.representative.value': 'SHINONOME TAKU',
  'commerce.operator.address.label': '주소',
  'commerce.operator.address.value': '요청 시 지체 없이 공개됩니다',
  'commerce.operator.phone.label': '전화번호',
  'commerce.operator.phone.value': '요청 시 지체 없이 공개됩니다 (이메일로 문의해 주세요)',
  'commerce.operator.email.label': '이메일 주소',
  'commerce.operator.email.value': 'support@kizuna.ai',
  'commerce.operator.url.label': 'URL',
  'commerce.operator.url.value': 'https://sokuji.kizuna.ai',

  // Price
  'commerce.price.title': '가격',
  'commerce.price.description': '가격은 다음과 같습니다. 모든 가격에는 세금이 포함되어 있습니다.',
  'commerce.price.items': '선불 잔액은 미국 달러(USD)로 표시되며, 결제하신 금액이 잔액에 추가됩니다|번역 요금은 선택한 AI 제공업체가 측정한 실제 사용량에 따라 부과되며, 시간당 예상 요금은 지갑 페이지에 표시됩니다|최소 구매 금액: 5 USD|최대 구매 금액: 100 USD',
  'commerce.price.tax': '일본 내 고객: 가격에 소비세가 포함되어 있습니다. 일본 외 고객: 거주 지역에 따라 현지 세금이 부과될 수 있습니다.',

  // Additional Fees
  'commerce.additionalFees.title': '추가 비용',
  'commerce.additionalFees.description': '본 서비스 이용 시 잔액 충전 금액 외에 추가 비용은 발생하지 않습니다.',

  // Payment
  'commerce.payment.title': '결제 방법',
  'commerce.payment.items': '신용카드|체크카드|Apple Pay|Google Pay|Link|알리페이(Alipay)',
  'commerce.payment.note': '결제는 Stripe, Inc.를 통해 처리됩니다. 사용 가능한 결제 수단은 Stripe의 지원 상황에 따라 다를 수 있습니다. 알리페이 결제는 미국 달러 금액을 결제 전에 표시되는 유럽중앙은행 기준 환율로 환산하여 일본 엔화로 청구됩니다.',

  // Payment Period
  'commerce.paymentPeriod.title': '결제 기한',
  'commerce.paymentPeriod.content': '신용카드 및 알리페이 결제는 구매 완료 즉시 처리됩니다.',

  // Delivery
  'commerce.delivery.title': '서비스 제공 시기',
  'commerce.delivery.items': '결제가 완료되면 선불 잔액이 즉시 계정에 적립됩니다|AI 번역 서비스는 실시간으로 제공됩니다. 잔액은 세션 종료 직후 제공업체가 사용량을 보고한 시점에 실제 사용량에 따라 차감됩니다|잔액은 구매일로부터 1년간 유효합니다',

  // Refund / Exchange Policy
  'commerce.refund.title': '반품 및 교환',
  'commerce.refund.customerRequest.title': '＜고객 사정에 의한 반품/교환＞',
  'commerce.refund.customerRequest.content': '디지털 서비스 특성상 구매 후 선불 잔액의 반품 및 교환은 원칙적으로 불가합니다. 단, 미사용 잔액의 경우 구매 후 14일 이내에 환불 요청이 가능합니다. 수수료가 부과될 수 있습니다. 환불을 요청하려면 구매 세부 정보와 환불 사유를 support@kizuna.ai로 보내주세요.',
  'commerce.refund.defect.title': '＜불량품/서비스 결함의 경우 반품/교환＞',
  'commerce.refund.defect.content': '기술적 문제로 서비스가 정상적으로 제공되지 않았거나 잔액이 잘못 차감된 경우 support@kizuna.ai로 연락해 주세요. 조사 후 영향을 받은 금액을 계정에 크레딧으로 지급해 드립니다.',

  // Environment
  'commerce.environment.title': '시스템 요구 사항',
  'commerce.environment.items': '브라우저 확장 프로그램: Chrome 116+, Edge 116+ (Chromium 기반)|데스크톱 앱: Windows 10+, macOS 13+, Linux (Ubuntu 20.04+ 권장)|인터넷 연결: 안정적인 광대역 연결 필요|마이크: 음성 번역을 위한 오디오 입력 장치 필요',

  // Contact
  'commerce.contact.title': '문의하기',
  'commerce.contact.description': '문의 사항이 있으시면 아래 채널로 연락해 주세요.',
  'commerce.contact.email': '이메일: support@kizuna.ai',
  'commerce.contact.github': 'GitHub: github.com/kizuna-ai-lab/sokuji',

  // Participant Audio Feature
  'nav.participantAudio': '상대방 오디오',

  // Overview

  // How It Works

  // Platform Support

  // How to Enable

  // Platform Differences

  // Tips

  // FAQ

  // Device Selection Guide

  // Uninstall Feedback
  'uninstall.loading': '설문을 불러오는 중...',
  'uninstall.retry': '다시 시도',
  'uninstall.fallbackTitle': '떠나시게 되어 아쉽습니다',
  'uninstall.fallbackSubtitle': '해당하는 모든 이유를 선택해 주세요. 여러분의 솔직한 피드백이 개선에 큰 도움이 됩니다.',
  'uninstall.otherPlaceholder': '자세히 알려주세요...',
  'uninstall.submitButton': '피드백 제출',
  'uninstall.tryDesktop': '{link} 사용해 보기 — 더 많은 기능, 모든 앱에서 작동',
  'uninstall.thankyouTitle': '피드백 감사합니다!',
  'uninstall.thankyouSubtitle': '소중한 시간을 내어 의견을 공유해 주셔서 감사합니다. 여러분의 피드백은 Sokuji를 개선하는 데 활용하겠습니다.',
  'uninstall.reinstallPrompt': '마음이 바뀌셨나요? 언제든지 Sokuji를 다시 설치할 수 있습니다.',
  'uninstall.reinstallButton': 'Chrome 웹 스토어에서 다시 설치',
  'uninstall.needMoreFeatures': '더 많은 기능이 필요하신가요?',
  'uninstall.needMoreFeaturesDesc': '지원되지 않는 웹사이트나 커스텀 API 제공업체가 필요하시다면 데스크톱 클라이언트를 사용해 보세요!',
  'uninstall.tryDesktopClient': 'Sokuji 데스크톱 클라이언트 사용해 보기',
  'uninstall.getInTouch': '문의하기',
  'uninstall.reportBug': '버그 신고:',
  'uninstall.shareIdea': '아이디어 공유:',
  'uninstall.copyright': '© {year} Sokuji. 모든 권리 보유.',
  // Subtitle Mode Feature
  'nav.subtitleMode': '자막 모드',
  'nav.basicFeatures': '기본 기능',
  'nav.feature.translationModes': '번역 모드',
  'nav.feature.virtualMicrophone': '가상 마이크',
  'nav.feature.textOnly': '음성 또는 텍스트만',
  'nav.feature.display': '표시 설정',
  'nav.feature.pronunciationReadings': '읽는 법 표시',
  'nav.feature.export': '내보내기 및 자동 저장',
  'nav.feature.replay': '다시 재생',
  'nav.feature.noiseSuppression': '노이즈 억제',
  'nav.feature.passthrough': '원음 패스스루',
  'nav.feature.switchDevices': '장치 전환',
  'nav.feature.diagnosticLogs': '진단 로그',
  'nav.feature.interfaceLanguage': '인터페이스 언어',
  'nav.feature.captionSharing': '자막 공유',

  // Overview

  // How to enter and exit

  // Floating bar layout

  // Customization

  // Pin and Lock

  // Compact vs. expanded rows

  // Tips and limitations

  // FAQ
  // Local models (/docs/local-models)
  'localModels.title': '로컬 모델과 라이선스',
  'localModels.intro': 'Sokuji의 무료 모드에서 다운로드할 수 있는 모든 모델의 용도, 크기, 출처, 그리고 가중치 라이선스를 정리했습니다.',
  'localModels.runtimeTitle': '모델 실행 환경',
  'localModels.runtimeBody': '모델은 브라우저 안에서 실행됩니다. CPU에서는 WebAssembly(WASM)로, GPU에서는 WebGPU로 실행됩니다. WebGPU 모델에는 WebGPU를 지원하는 브라우저와 그래픽 카드가 필요합니다. 그 밖의 실행 속도는 기기에 따라 다릅니다. 크기는 다운로드 용량으로, Sokuji 모델 목록에 표시되는 숫자와 같습니다. 모델을 불러오려면 최소한 이만큼의 메모리가 필요합니다.',
  'localModels.variantsNote': '여러 변형이 있는 모델은 Sokuji가 기기에서 지원하는 변형을 선택합니다. 이름에 f16이 들어간 변형은 16비트 셰이더를 지원하는 GPU가 필요합니다.',
  'localModels.licenseTitle': '라이선스',
  'localModels.licenseBody': 'Sokuji 자체는 AGPL-3.0으로 공개된 무료 오픈 소스입니다. 모델은 Sokuji의 일부가 아니며, 각 모델은 게시자가 자체 라이선스로 제공하고 아래에 표시되어 있습니다. 일부는 비상업적 사용만 허용하고, 일부는 라이선스를 전혀 명시하지 않습니다. 모델을 사용할 때는 게시자의 조건을 따라야 합니다.',
  'localModels.tier.open.label': '개방형 라이선스',
  'localModels.tier.open.desc': '허용적이거나 저작자 표시만 요구하는 라이선스입니다: MIT, Apache-2.0, BSD, CC0, CC BY, CC BY-SA.',
  'localModels.tier.conditional.label': '조건부',
  'localModels.tier.conditional.desc': '사용할 수 있지만 저작자 표시 외에 지역 제한, 사용 정책, 카피레프트 같은 조건이 있습니다. 자세한 내용은 비고를 참고하세요.',
  'localModels.tier.non-commercial.label': '비상업용',
  'localModels.tier.non-commercial.desc': '게시자가 비상업적 사용만 허용하거나, 상업적 사용은 자체 조건으로만 허용합니다.',
  'localModels.tier.unstated.label': '라이선스 미명시',
  'localModels.tier.unstated.desc': '게시자가 라이선스를 부여하지 않았습니다.',
  'localModels.tier.cloud.label': '온라인 서비스',
  'localModels.tier.cloud.desc': '다운로드가 필요 없습니다. 텍스트를 온라인 서비스로 보내므로 인터넷 연결이 필요합니다.',
  'localModels.flag.non-commercial-base': '비상업용 기반 음성',
  'localModels.flag.removed-upstream': '게시자가 철회함',
  'localModels.flag.game-character': '게임 캐릭터 음성',
  'localModels.flagNcBase': '비상업용 기반 음성: 학습 데이터가 비상업적 사용으로만 허가된 Piper 음성(lessac 또는 ryan)을 기반으로 미세 조정한 음성입니다. 이 음성 자체의 라이선스에는 그 조건이 이어지는지 명시되어 있지 않습니다.',
  'localModels.type.asr': '음성 인식',
  'localModels.type.asr-stream': '스트리밍 음성 인식',
  'localModels.type.translation': '번역',
  'localModels.type.tts': '음성 합성',
  'localModels.type.punctuation': '문장 부호',
  'localModels.runtime.wasm': 'CPU(WASM)',
  'localModels.runtime.webgpu': 'WebGPU',
  'localModels.runtime.cloud': '온라인',
  'localModels.col.model': '모델',
  'localModels.col.languages': '언어',
  'localModels.col.runtime': '실행 환경',
  'localModels.col.size': '크기',
  'localModels.col.source': '출처',
  'localModels.col.license': '라이선스',
  'localModels.col.notes': '비고',
  'localModels.multilingual': '다국어',
  'localModels.package': '패키지',
  'localModels.filterLabel': '라이선스',
  'localModels.search': '이름, 언어, 라이선스로 필터링',
  'localModels.showing': '모델 {count}개 표시 중',
  'localModels.noMatch': '필터와 일치하는 모델이 없습니다.',
  'localModels.bundled': '모든 오프라인 음성 인식 패키지에 포함:',
  'localModels.generatedFrom': 'Sokuji {version} 기준으로 생성했습니다.',

  // Account deletion page
  'deleteAccount.title': 'Sokuji 계정 삭제',
  'deleteAccount.intro': 'Sokuji는 Kizuna AI가 개발합니다. Android 및 iOS 앱을 포함한 모든 플랫폼에서 Kizuna AI 계정으로 Sokuji에 로그인합니다. 이 페이지에서는 계정을 삭제하는 방법과 데이터 처리 방식을 설명합니다. 삭제한 계정은 복구할 수 없습니다.',
  'deleteAccount.app.title': 'Sokuji 모바일 앱에서',
  'deleteAccount.app.items': '기본 화면에서 메뉴를 엽니다|계정을 탭합니다|계정 삭제를 탭하고 확인합니다',
  'deleteAccount.web.title': '웹사이트에서',
  'deleteAccount.web.items': 'sokuji.kizuna.ai에 로그인합니다|대시보드를 열고 보안으로 이동합니다|내 계정 삭제를 선택하고 DELETE를 입력해 확인합니다',
  'deleteAccount.email.title': '로그인할 수 없는 경우',
  'deleteAccount.email.content': '계정 이메일 주소로 privacy@kizuna.ai에 메일을 보내 삭제를 요청하세요.',
  'deleteAccount.deleted.title': '삭제되는 항목',
  'deleteAccount.deleted.items': '이메일 주소, 표시 이름, 비밀번호, 로그인 기록을 포함한 계정|남은 잔액(복구할 수 없습니다)|직접 만든 사용자 지정 음성',
  'deleteAccount.partial.title': '계정을 삭제하지 않고 일부 데이터 삭제',
  'deleteAccount.partial.items': '기기에 저장된 대화 기록: 앱에서 기록을 열어 삭제합니다|사용 분석 데이터: privacy@kizuna.ai에 메일을 보내 삭제를 요청하세요',
};

export default ko;
